/* eslint-disable */
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };


/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Any: { input: any; output: any; }
  DateTimeISO: { input: string; output: string; }
  JSON: { input: any; output: any; }
};

export enum Ability {
  Charisma = 'Charisma',
  Constitution = 'Constitution',
  Dexterity = 'Dexterity',
  Intelligence = 'Intelligence',
  Strength = 'Strength',
  Wisdom = 'Wisdom'
}

export enum ActionType {
  Attack = 'Attack',
  FirstAttack = 'FirstAttack',
  Multiattack = 'Multiattack',
  Other = 'Other',
  Save = 'Save',
  Spellcasting = 'Spellcasting'
}

export type AdminComment = {
  authorBlocked: Scalars['Boolean']['output'];
  authorId: Scalars['String']['output'];
  authorName: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  editedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  targetId: Scalars['String']['output'];
  targetParentId?: Maybe<Scalars['String']['output']>;
  targetTitle?: Maybe<Scalars['String']['output']>;
  targetType: CommentTargetType;
  text: Scalars['String']['output'];
};

export type AdminCommentsPage = {
  items: Array<AdminComment>;
  total: Scalars['Int']['output'];
};

export enum AgeType {
  Futuristic = 'Futuristic',
  Modern = 'Modern',
  Renaissance = 'Renaissance'
}

export enum AttackType {
  Melee = 'Melee',
  Ranged = 'Ranged'
}

export type Book = {
  alternativeTitles?: Maybe<Array<Scalars['String']['output']>>;
  available: Scalars['Boolean']['output'];
  chapters?: Maybe<Array<BookChapter>>;
  cover?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  group?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  level?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  originalTitle: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['String']['output']>;
  storyline?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type BookBlockContent = {
  href: Scalars['String']['output'];
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  portrait: Scalars['Boolean']['output'];
  side: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type BookBlockMove = {
  block: Scalars['String']['output'];
  chapter: BookChapter;
};

export type BookChapter = {
  bookId: Scalars['String']['output'];
  content?: Maybe<Scalars['Any']['output']>;
  customToc: Scalars['Boolean']['output'];
  endPage?: Maybe<Scalars['Float']['output']>;
  headings?: Maybe<Scalars['Any']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  order: Scalars['Float']['output'];
  page?: Maybe<Scalars['Float']['output']>;
  part?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  toc?: Maybe<Scalars['Any']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type BookInput = {
  cover?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
};

export type BookParagraphForm = {
  id: Scalars['String']['output'];
  level?: Maybe<Scalars['Int']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type BookParagraphMove = {
  chapter: BookChapter;
  paragraph: Scalars['String']['output'];
};

export enum CastingTimeUnit {
  Action = 'Action',
  Bonus = 'Bonus',
  Hour = 'Hour',
  Minute = 'Minute',
  Reaction = 'Reaction'
}

export type CharacterSheet = {
  createdAt: Scalars['DateTimeISO']['output'];
  data: Scalars['Any']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  userId: Scalars['String']['output'];
};

export type Class = {
  cases: GrammaticalCase;
  choose?: Maybe<Scalars['Any']['output']>;
  columns: Array<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  equipment: Scalars['String']['output'];
  features?: Maybe<Array<Feature>>;
  hasSpells: Scalars['Boolean']['output'];
  hitDie: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  images?: Maybe<Array<Image>>;
  legacyDescription?: Maybe<Scalars['String']['output']>;
  multiClassing: Scalars['String']['output'];
  originalTitle: Scalars['String']['output'];
  primaryAbility: Array<Ability>;
  props?: Maybe<Scalars['Any']['output']>;
  rows?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  saves: Array<Ability>;
  sections?: Maybe<Scalars['Any']['output']>;
  shortDescription: Scalars['String']['output'];
  source?: Maybe<Array<Source>>;
  spells?: Maybe<Array<Spell>>;
  subClassDescription: Scalars['String']['output'];
  subClasses?: Maybe<Array<SubClass>>;
  title: Scalars['String']['output'];
  trainingTable?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  updatedAt: Scalars['DateTimeISO']['output'];
};


export type ClasssubClassesArgs = {
  classIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClassInput = {
  columns?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<FeatureInput>>;
  hasSpells?: InputMaybe<Scalars['Boolean']['input']>;
  hitDie?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  primaryAbility?: InputMaybe<Array<Scalars['String']['input']>>;
  saves?: InputMaybe<Array<Scalars['String']['input']>>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<SourceInput>>;
  subClassDescription?: InputMaybe<Scalars['String']['input']>;
  subClassTitle?: InputMaybe<Scalars['String']['input']>;
  subClasses?: InputMaybe<Array<SubClassInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Comment = {
  authorId: Scalars['String']['output'];
  authorName: Scalars['String']['output'];
  createdAt: Scalars['DateTimeISO']['output'];
  editedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  editedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isDeleted: Scalars['Boolean']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  targetId: Scalars['String']['output'];
  targetType: CommentTargetType;
  text: Scalars['String']['output'];
};

export type CommentActivity = {
  lastCommentAt: Scalars['DateTimeISO']['output'];
  targetId: Scalars['String']['output'];
  targetType: CommentTargetType;
};

export enum CommentTargetType {
  Book = 'Book',
  Class = 'Class',
  Feat = 'Feat',
  Glossary = 'Glossary',
  Item = 'Item',
  Monster = 'Monster',
  Origin = 'Origin',
  Specie = 'Specie',
  Spell = 'Spell',
  SubClass = 'SubClass',
  Wiki = 'Wiki'
}

export enum ConditionType {
  Blinded = 'Blinded',
  Charmed = 'Charmed',
  Deafened = 'Deafened',
  Exhaustion = 'Exhaustion',
  Frightened = 'Frightened',
  Grappled = 'Grappled',
  Incapacitated = 'Incapacitated',
  Invisible = 'Invisible',
  Paralyzed = 'Paralyzed',
  Petrified = 'Petrified',
  Poisoned = 'Poisoned',
  Prone = 'Prone',
  Restrained = 'Restrained',
  Stunned = 'Stunned',
  Unconscious = 'Unconscious'
}

export enum DamageType {
  acid = 'acid',
  bludgeoning = 'bludgeoning',
  cold = 'cold',
  fire = 'fire',
  force = 'force',
  lightning = 'lightning',
  necrotic = 'necrotic',
  piercing = 'piercing',
  poison = 'poison',
  psychic = 'psychic',
  radiant = 'radiant',
  slashing = 'slashing',
  thunder = 'thunder'
}

export type DayCard = {
  id: Scalars['String']['output'];
  imagePath?: Maybe<Scalars['String']['output']>;
  kind: Scalars['String']['output'];
  originalTitle?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export enum DistanceType {
  Feet = 'Feet',
  Miles = 'Miles',
  Self = 'Self',
  Sight = 'Sight',
  Touch = 'Touch',
  Unlimited = 'Unlimited'
}

export enum DurationType {
  Instant = 'Instant',
  Permanent = 'Permanent',
  Special = 'Special',
  Timed = 'Timed'
}

export enum DurationUnit {
  Day = 'Day',
  Hour = 'Hour',
  Minute = 'Minute',
  Round = 'Round'
}

export type Feat = {
  alternativeTitles?: Maybe<Array<Scalars['String']['output']>>;
  basicRules?: Maybe<Scalars['Boolean']['output']>;
  category: FeatCategory;
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Feature>>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<Image>>;
  originalTitle: Scalars['String']['output'];
  prerequisite?: Maybe<Scalars['String']['output']>;
  repeatable?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Array<Source>>;
  spells?: Maybe<Array<Spell>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  variantKey?: Maybe<Scalars['String']['output']>;
};

export enum FeatCategory {
  EpicBones = 'EpicBones',
  FightingStyle = 'FightingStyle',
  General = 'General',
  Origin = 'Origin',
  PlanarPact = 'PlanarPact'
}

/** Фильтр списка черт */
export type FeatFilterInput = {
  categories?: InputMaybe<Array<FeatCategory>>;
  sources?: InputMaybe<Array<SourceBook>>;
};

export type FeatInput = {
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<FeatCategory>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  prerequisite?: InputMaybe<Scalars['String']['input']>;
  repeatable?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Array<SourceInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Feature = {
  alternativeTitles?: Maybe<Array<Scalars['String']['output']>>;
  choose?: Maybe<Array<Scalars['Any']['output']>>;
  class?: Maybe<Class>;
  classId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  feat?: Maybe<Feat>;
  featId?: Maybe<Scalars['String']['output']>;
  headingLevel?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  levelTitles?: Maybe<Array<Scalars['String']['output']>>;
  levels?: Maybe<Array<Scalars['String']['output']>>;
  option?: Maybe<Scalars['Boolean']['output']>;
  order?: Maybe<Scalars['Float']['output']>;
  originalTitle: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  prerequisite?: Maybe<Scalars['String']['output']>;
  props?: Maybe<Scalars['Any']['output']>;
  source?: Maybe<Array<Source>>;
  specie?: Maybe<Specie>;
  specieId?: Maybe<Scalars['String']['output']>;
  spells?: Maybe<Array<Spell>>;
  subClass?: Maybe<SubClass>;
  subClassId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type?: Maybe<FeatureType>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type FeatureInput = {
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  levelTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  levels?: InputMaybe<Array<Scalars['String']['input']>>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  prerequisite?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum FeatureType {
  ArcaneShot = 'ArcaneShot',
  Invocation = 'Invocation',
  Maneuver = 'Maneuver',
  Metamagic = 'Metamagic',
  WildMagic = 'WildMagic'
}

export type GameMap = {
  description?: Maybe<Scalars['String']['output']>;
  height: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  labels: Array<MapLabel>;
  maxZoom: Scalars['Int']['output'];
  milesPerPixel?: Maybe<Scalars['Float']['output']>;
  order: Scalars['Int']['output'];
  originalTitle: Scalars['String']['output'];
  paths: Array<MapPath>;
  preview?: Maybe<Scalars['String']['output']>;
  tilePath: Scalars['String']['output'];
  tileSize: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  width: Scalars['Int']['output'];
};

export type GlobalDescription = {
  description: Scalars['String']['output'];
  headingLevel?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  originalTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type GlossaryItem = {
  alternativeTitles?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  originalDescription?: Maybe<Scalars['String']['output']>;
  originalTitle: Scalars['String']['output'];
  source?: Maybe<Array<Source>>;
  title: Scalars['String']['output'];
  type?: Maybe<GlossaryType>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type GlossaryItemInput = {
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<SourceInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum GlossaryType {
  Action = 'Action',
  AreaOfEffect = 'AreaOfEffect',
  Attitude = 'Attitude',
  Condition = 'Condition',
  Hazard = 'Hazard'
}

export type GrammaticalCase = {
  genitive: Scalars['String']['output'];
};

export type Image = {
  credits?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  height?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  originDescription?: Maybe<Scalars['String']['output']>;
  path: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  width?: Maybe<Scalars['Float']['output']>;
};

export enum ImageTarget {
  Class = 'Class',
  Feat = 'Feat',
  Item = 'Item',
  Monster = 'Monster',
  Origin = 'Origin',
  Specie = 'Specie',
  Spell = 'Spell',
  SubClass = 'SubClass'
}

export type Item = {
  ability?: Maybe<Scalars['Any']['output']>;
  ac?: Maybe<Scalars['Int']['output']>;
  age?: Maybe<AgeType>;
  alternativeTitles?: Maybe<Array<Scalars['String']['output']>>;
  ammoId?: Maybe<Scalars['String']['output']>;
  ammoItem?: Maybe<Item>;
  attachedSpells?: Maybe<Array<Scalars['String']['output']>>;
  baseItem?: Maybe<Item>;
  baseItemId?: Maybe<Scalars['String']['output']>;
  basicRules?: Maybe<Scalars['Boolean']['output']>;
  bonusAbilityCheck?: Maybe<Scalars['String']['output']>;
  bonusAc?: Maybe<Scalars['Int']['output']>;
  bonusProficiencyBonus?: Maybe<Scalars['String']['output']>;
  bonusSavingThrow?: Maybe<Scalars['String']['output']>;
  bonusSpellAttack?: Maybe<Scalars['String']['output']>;
  bonusSpellSaveDc?: Maybe<Scalars['String']['output']>;
  bonusWeapon?: Maybe<Scalars['String']['output']>;
  bonusWeaponDamage?: Maybe<Scalars['String']['output']>;
  capCargo?: Maybe<Scalars['Float']['output']>;
  capPassenger?: Maybe<Scalars['Int']['output']>;
  carryingCapacity?: Maybe<Scalars['Int']['output']>;
  charges?: Maybe<Scalars['String']['output']>;
  choose?: Maybe<Array<Scalars['Any']['output']>>;
  conditionImmune?: Maybe<Array<ConditionType>>;
  containerCapacity?: Maybe<Scalars['Any']['output']>;
  crew?: Maybe<Scalars['Int']['output']>;
  curse?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dimensions?: Maybe<Scalars['Any']['output']>;
  dmg1?: Maybe<Scalars['String']['output']>;
  dmg2?: Maybe<Scalars['String']['output']>;
  dmgType?: Maybe<DamageType>;
  excludes?: Maybe<ItemRequires>;
  globalDescriptions?: Maybe<Array<GlobalDescription>>;
  grantsProficiency?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<Image>>;
  immune?: Maybe<Array<DamageType>>;
  itemIds?: Maybe<Array<Scalars['String']['output']>>;
  legacyItem?: Maybe<Item>;
  legacyItemId?: Maybe<Scalars['String']['output']>;
  light?: Maybe<Scalars['Any']['output']>;
  lootTables?: Maybe<Array<Scalars['String']['output']>>;
  modifySpeed?: Maybe<Scalars['Any']['output']>;
  mountMonster?: Maybe<Monster>;
  originalTitle: Scalars['String']['output'];
  packContents?: Maybe<Scalars['Any']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  parentItem?: Maybe<Item>;
  poisonType?: Maybe<PoisonType>;
  price?: Maybe<Scalars['Float']['output']>;
  props?: Maybe<Scalars['Any']['output']>;
  range?: Maybe<Scalars['String']['output']>;
  rarity: ItemRarity;
  recharge?: Maybe<RechargeTime>;
  rechargeAmount?: Maybe<Scalars['String']['output']>;
  reloadCount?: Maybe<Scalars['Int']['output']>;
  reqAttune?: Maybe<Scalars['Boolean']['output']>;
  reqAttuneTags?: Maybe<Scalars['Any']['output']>;
  reqAttuneText?: Maybe<Scalars['String']['output']>;
  requires?: Maybe<ItemRequires>;
  resist?: Maybe<Array<DamageType>>;
  sentient?: Maybe<Scalars['Boolean']['output']>;
  sets?: Maybe<Array<Scalars['String']['output']>>;
  source?: Maybe<Array<Source>>;
  speed?: Maybe<Scalars['Int']['output']>;
  spellScrollLevel?: Maybe<Scalars['Int']['output']>;
  stealth?: Maybe<Scalars['Boolean']['output']>;
  strength?: Maybe<Scalars['Int']['output']>;
  subType?: Maybe<Array<ItemSubType>>;
  tier?: Maybe<ItemTier>;
  title: Scalars['String']['output'];
  type?: Maybe<ItemType>;
  updatedAt: Scalars['DateTimeISO']['output'];
  valueRarity?: Maybe<ItemRarity>;
  vehAc?: Maybe<Scalars['Int']['output']>;
  vehDmgThresh?: Maybe<Scalars['Int']['output']>;
  vehHp?: Maybe<Scalars['Int']['output']>;
  vehSpeed?: Maybe<Scalars['Float']['output']>;
  vulnerable?: Maybe<Array<DamageType>>;
  weaponCategory?: Maybe<WeaponCategory>;
  weaponMastery?: Maybe<Array<WeaponMastery>>;
  weaponMasteryNote?: Maybe<Scalars['String']['output']>;
  weaponProperty?: Maybe<Array<WeaponProperty>>;
  weight?: Maybe<Scalars['Float']['output']>;
  wondrous?: Maybe<Scalars['Boolean']['output']>;
};

/** Фильтр списка предметов; внутри одного поля значения объединяются через «или» */
export type ItemFilterInput = {
  curse?: InputMaybe<Scalars['Boolean']['input']>;
  rarities?: InputMaybe<Array<ItemRarity>>;
  reqAttune?: InputMaybe<Scalars['Boolean']['input']>;
  sources?: InputMaybe<Array<SourceBook>>;
  subTypes?: InputMaybe<Array<ItemSubType>>;
  /** Книжные типы */
  types?: InputMaybe<Array<ItemType>>;
  /** Чудесные предметы; вместе с types — через «или», как ещё один книжный тип */
  wondrous?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ItemInput = {
  ac?: InputMaybe<Scalars['Float']['input']>;
  age?: InputMaybe<AgeType>;
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  bonusAc?: InputMaybe<Scalars['Float']['input']>;
  bonusWeapon?: InputMaybe<Scalars['String']['input']>;
  bonusWeaponDamage?: InputMaybe<Scalars['String']['input']>;
  capCargo?: InputMaybe<Scalars['Float']['input']>;
  capPassenger?: InputMaybe<Scalars['Float']['input']>;
  carryingCapacity?: InputMaybe<Scalars['Float']['input']>;
  crew?: InputMaybe<Scalars['Float']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dmg1?: InputMaybe<Scalars['String']['input']>;
  dmg2?: InputMaybe<Scalars['String']['input']>;
  dmgType?: InputMaybe<DamageType>;
  id?: InputMaybe<Scalars['String']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  poisonType?: InputMaybe<PoisonType>;
  price?: InputMaybe<Scalars['Float']['input']>;
  range?: InputMaybe<Scalars['String']['input']>;
  rarity?: InputMaybe<ItemRarity>;
  reloadCount?: InputMaybe<Scalars['Float']['input']>;
  reqAttune?: InputMaybe<Scalars['Boolean']['input']>;
  reqAttuneText?: InputMaybe<Scalars['String']['input']>;
  speed?: InputMaybe<Scalars['Float']['input']>;
  stealth?: InputMaybe<Scalars['Boolean']['input']>;
  strength?: InputMaybe<Scalars['Float']['input']>;
  subType?: InputMaybe<Array<ItemSubType>>;
  tier?: InputMaybe<ItemTier>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<ItemType>;
  vehAc?: InputMaybe<Scalars['Float']['input']>;
  vehDmgThresh?: InputMaybe<Scalars['Float']['input']>;
  vehHp?: InputMaybe<Scalars['Float']['input']>;
  vehSpeed?: InputMaybe<Scalars['Float']['input']>;
  weaponCategory?: InputMaybe<WeaponCategory>;
  weaponProperty?: InputMaybe<Array<WeaponProperty>>;
  weight?: InputMaybe<Scalars['Float']['input']>;
  wondrous?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ItemRarity {
  Artifact = 'Artifact',
  Common = 'Common',
  Legendary = 'Legendary',
  None = 'None',
  Rare = 'Rare',
  Uncommon = 'Uncommon',
  Unknown = 'Unknown',
  UnknownMagic = 'UnknownMagic',
  Varies = 'Varies',
  VeryRare = 'VeryRare'
}

export type ItemRequires = {
  items?: Maybe<Array<SimpleItem>>;
  types?: Maybe<Array<ItemTypeDetail>>;
  weaponCategories?: Maybe<Array<WeaponCategory>>;
};

export enum ItemSubType {
  Air = 'Air',
  Ammunition = 'Ammunition',
  ArtObject = 'ArtObject',
  Gemstone = 'Gemstone',
  Heavy = 'Heavy',
  Instrument = 'Instrument',
  Light = 'Light',
  Medium = 'Medium',
  Melee = 'Melee',
  Ranged = 'Ranged',
  Shield = 'Shield',
  Water = 'Water'
}

export enum ItemTier {
  Major = 'Major',
  Minor = 'Minor'
}

export enum ItemType {
  AdventuringGear = 'AdventuringGear',
  Armor = 'Armor',
  ArtisansTools = 'ArtisansTools',
  Explosive = 'Explosive',
  FoodAndDrink = 'FoodAndDrink',
  GamingSet = 'GamingSet',
  Mount = 'Mount',
  Poison = 'Poison',
  Potion = 'Potion',
  Ring = 'Ring',
  Rod = 'Rod',
  Scroll = 'Scroll',
  Ship = 'Ship',
  SpellcastingFocus = 'SpellcastingFocus',
  Staff = 'Staff',
  TackAndHarness = 'TackAndHarness',
  Tool = 'Tool',
  TradeBar = 'TradeBar',
  TradeGood = 'TradeGood',
  Treasure = 'Treasure',
  Vehicle = 'Vehicle',
  Wand = 'Wand',
  Weapon = 'Weapon'
}

export enum ItemTypeDetail {
  AdventuringGear = 'AdventuringGear',
  Ammunition = 'Ammunition',
  AmmunitionFirearms = 'AmmunitionFirearms',
  AnimalArmor = 'AnimalArmor',
  AnyAmmunition = 'AnyAmmunition',
  AnyArmor = 'AnyArmor',
  AnyWeapon = 'AnyWeapon',
  ArtisansTools = 'ArtisansTools',
  BurstFire = 'BurstFire',
  Explosive = 'Explosive',
  FoodAndDrink = 'FoodAndDrink',
  GamingSet = 'GamingSet',
  HeavyArmor = 'HeavyArmor',
  Instrument = 'Instrument',
  LightArmor = 'LightArmor',
  MediumArmor = 'MediumArmor',
  MeleeWeapon = 'MeleeWeapon',
  Mount = 'Mount',
  Other = 'Other',
  Poison = 'Poison',
  Potion = 'Potion',
  RangedWeapon = 'RangedWeapon',
  Ring = 'Ring',
  Rod = 'Rod',
  Scroll = 'Scroll',
  Shield = 'Shield',
  SpellcastingFocus = 'SpellcastingFocus',
  Staff = 'Staff',
  TackAndHarness = 'TackAndHarness',
  Tool = 'Tool',
  TradeBar = 'TradeBar',
  TradeGood = 'TradeGood',
  TreasureArtObject = 'TreasureArtObject',
  TreasureGemstone = 'TreasureGemstone',
  VehicleAir = 'VehicleAir',
  VehicleLand = 'VehicleLand',
  VehicleWater = 'VehicleWater',
  Wand = 'Wand'
}

export type Language = {
  description?: Maybe<Scalars['String']['output']>;
  exotic?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  originalTitle: Scalars['String']['output'];
  parent?: Maybe<Scalars['String']['output']>;
  script?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Array<Source>>;
  speakers?: Maybe<Scalars['String']['output']>;
  standard?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type LegacyMonsterDescription = {
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type MapLabel = {
  align: Scalars['String']['output'];
  angle: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  layer: Scalars['String']['output'];
  lines: Scalars['Int']['output'];
  mapId: Scalars['String']['output'];
  marker?: Maybe<Scalars['String']['output']>;
  markerX?: Maybe<Scalars['Int']['output']>;
  markerY?: Maybe<Scalars['Int']['output']>;
  originalTitle: Scalars['String']['output'];
  polygon?: Maybe<Array<Array<Scalars['Int']['output']>>>;
  size: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
  wikiArticleId?: Maybe<Scalars['String']['output']>;
  x: Scalars['Int']['output'];
  y: Scalars['Int']['output'];
};

export type MapLabelCreateInput = {
  kind: Scalars['String']['input'];
  layer?: InputMaybe<Scalars['String']['input']>;
  marker?: InputMaybe<Scalars['String']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  x: Scalars['Int']['input'];
  y: Scalars['Int']['input'];
};

export type MapLabelGeometryInput = {
  id: Scalars['Int']['input'];
  markerX?: InputMaybe<Scalars['Int']['input']>;
  markerY?: InputMaybe<Scalars['Int']['input']>;
  polygon?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
  x?: InputMaybe<Scalars['Int']['input']>;
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type MapLabelInput = {
  kind?: InputMaybe<Scalars['String']['input']>;
  marker?: InputMaybe<Scalars['String']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  wikiArticleId?: InputMaybe<Scalars['String']['input']>;
};

export type MapPath = {
  id: Scalars['Int']['output'];
  kind: Scalars['String']['output'];
  mapId: Scalars['String']['output'];
  points: Array<Scalars['Int']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type MapPathGeometryInput = {
  id: Scalars['Int']['input'];
  points: Array<Scalars['Int']['input']>;
};

export type Monster = {
  ac?: Maybe<Scalars['Float']['output']>;
  acNote?: Maybe<Scalars['String']['output']>;
  actions?: Maybe<Array<MonsterTrait>>;
  alignment?: Maybe<Array<Scalars['String']['output']>>;
  alternativeTitles?: Maybe<Array<Scalars['String']['output']>>;
  bonusActions?: Maybe<Array<MonsterTrait>>;
  cha: Scalars['Float']['output'];
  con: Scalars['Float']['output'];
  conditionImmune?: Maybe<Array<Scalars['Any']['output']>>;
  cr?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dex: Scalars['Float']['output'];
  features?: Maybe<Array<MonsterTrait>>;
  gear?: Maybe<Array<Scalars['Any']['output']>>;
  globalDescriptions: Array<GlobalDescription>;
  group?: Maybe<MonsterGroup>;
  groupId?: Maybe<Scalars['String']['output']>;
  groupTmp?: Maybe<Scalars['String']['output']>;
  hp: Scalars['String']['output'];
  id: Scalars['String']['output'];
  images?: Maybe<Array<Image>>;
  immune?: Maybe<Array<Scalars['Any']['output']>>;
  initiativeProfBonus?: Maybe<Scalars['Float']['output']>;
  int: Scalars['Float']['output'];
  lairGroupId?: Maybe<Scalars['String']['output']>;
  lairTraits?: Maybe<Array<MonsterTrait>>;
  languages?: Maybe<Scalars['Any']['output']>;
  legacyDescriptionId?: Maybe<Scalars['String']['output']>;
  legacyDescriptions?: Maybe<Array<LegacyMonsterDescription>>;
  legacyMonsters?: Maybe<Array<Monster>>;
  legacyTitles?: Maybe<Array<Scalars['String']['output']>>;
  legendaryActions?: Maybe<Array<MonsterTrait>>;
  legendaryActionsCount?: Maybe<Scalars['Float']['output']>;
  legendaryActionsLairCount?: Maybe<Scalars['Float']['output']>;
  monsterLair?: Maybe<MonsterLair>;
  mount?: Maybe<Item>;
  originalDescription?: Maybe<Scalars['String']['output']>;
  originalTitle: Scalars['String']['output'];
  passive: Scalars['Float']['output'];
  proficiencyNote?: Maybe<Scalars['String']['output']>;
  reactions?: Maybe<Array<MonsterTrait>>;
  resist?: Maybe<Array<Scalars['Any']['output']>>;
  saves?: Maybe<Scalars['Any']['output']>;
  senses?: Maybe<Array<Scalars['Any']['output']>>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Array<Size>>;
  skills?: Maybe<Scalars['Any']['output']>;
  source?: Maybe<Array<Source>>;
  speed?: Maybe<Scalars['Any']['output']>;
  str: Scalars['Float']['output'];
  subType?: Maybe<Array<Scalars['String']['output']>>;
  swarmSize?: Maybe<Size>;
  telepathy?: Maybe<Scalars['Any']['output']>;
  title: Scalars['String']['output'];
  token?: Maybe<Image>;
  types: Array<Scalars['String']['output']>;
  understandLanguages?: Maybe<Scalars['Any']['output']>;
  updatedAt: Scalars['DateTimeISO']['output'];
  vulnerable?: Maybe<Array<Scalars['Any']['output']>>;
  wis: Scalars['Float']['output'];
  xpLair?: Maybe<Scalars['Float']['output']>;
};

export type MonsterDescriptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

/** Фильтр списка чудовищ */
export type MonsterFilterInput = {
  sources?: InputMaybe<Array<SourceBook>>;
};

export type MonsterGroup = {
  about?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  environment?: Maybe<Array<Scalars['String']['output']>>;
  id: Scalars['String']['output'];
  originalAbout?: Maybe<Scalars['String']['output']>;
  originalDescription?: Maybe<Scalars['String']['output']>;
  originalTitle: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  treasure?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type MonsterGroupInput = {
  about?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  environment?: InputMaybe<Array<Scalars['String']['input']>>;
  originalAbout?: InputMaybe<Scalars['String']['input']>;
  originalDescription?: InputMaybe<Scalars['String']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  treasure?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type MonsterInput = {
  ac?: InputMaybe<Scalars['Float']['input']>;
  acNote?: InputMaybe<Scalars['String']['input']>;
  alignment?: InputMaybe<Scalars['JSON']['input']>;
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  cha?: InputMaybe<Scalars['Float']['input']>;
  con?: InputMaybe<Scalars['Float']['input']>;
  conditionImmune?: InputMaybe<Scalars['JSON']['input']>;
  cr?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  dex?: InputMaybe<Scalars['Float']['input']>;
  environment?: InputMaybe<Scalars['JSON']['input']>;
  features?: InputMaybe<Array<MonsterTraitInput>>;
  gear?: InputMaybe<Scalars['JSON']['input']>;
  groupId?: InputMaybe<Scalars['String']['input']>;
  hp?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  immune?: InputMaybe<Scalars['JSON']['input']>;
  initiativeProfBonus?: InputMaybe<Scalars['Float']['input']>;
  int?: InputMaybe<Scalars['Float']['input']>;
  languages?: InputMaybe<Scalars['JSON']['input']>;
  legendaryActionsCount?: InputMaybe<Scalars['Float']['input']>;
  legendaryActionsLairCount?: InputMaybe<Scalars['Float']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  passive?: InputMaybe<Scalars['Float']['input']>;
  proficiencyNote?: InputMaybe<Scalars['String']['input']>;
  resist?: InputMaybe<Scalars['JSON']['input']>;
  saves?: InputMaybe<Scalars['JSON']['input']>;
  senses?: InputMaybe<Scalars['JSON']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Array<Size>>;
  skills?: InputMaybe<Scalars['JSON']['input']>;
  source?: InputMaybe<Array<SourceInput>>;
  speed?: InputMaybe<Scalars['JSON']['input']>;
  str?: InputMaybe<Scalars['Float']['input']>;
  subType?: InputMaybe<Scalars['JSON']['input']>;
  swarmSize?: InputMaybe<Size>;
  telepathy?: InputMaybe<Scalars['JSON']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  treasure?: InputMaybe<Scalars['JSON']['input']>;
  types?: InputMaybe<Scalars['JSON']['input']>;
  understandLanguages?: InputMaybe<Scalars['JSON']['input']>;
  vulnerable?: InputMaybe<Scalars['JSON']['input']>;
  wis?: InputMaybe<Scalars['Float']['input']>;
  xpLair?: InputMaybe<Scalars['Float']['input']>;
};

export type MonsterLair = {
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<MonsterTrait>>;
  id: Scalars['String']['output'];
  monsters?: Maybe<Array<Monster>>;
  originalDescription?: Maybe<Scalars['String']['output']>;
  originalTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type MonsterTrait = {
  actionType?: Maybe<ActionType>;
  availSpells?: Maybe<Array<TraitSpellLine>>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  originalDescription?: Maybe<Scalars['String']['output']>;
  originalTitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: TraitType;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type MonsterTraitInput = {
  actionType?: InputMaybe<ActionType>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  monsterId?: InputMaybe<Scalars['String']['input']>;
  monsterLairId?: InputMaybe<Scalars['String']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TraitType>;
};

export type Mutation = {
  addBookBlock: BookBlockMove;
  addBookParagraph: BookParagraphMove;
  addEntityImage: Image;
  createCharacterSheet: CharacterSheet;
  createClass: Class;
  createComment: Comment;
  createMapLabel: MapLabel;
  createSpell: Spell;
  createWikiArticle: WikiArticle;
  deleteBookBlock: BookChapter;
  deleteBookParagraphs: BookChapter;
  deleteCharacterSheet: Scalars['Boolean']['output'];
  deleteComment: Scalars['Boolean']['output'];
  deleteEntityImage?: Maybe<Scalars['String']['output']>;
  deleteMapLabel: Scalars['Boolean']['output'];
  deletePasskey: Scalars['Boolean']['output'];
  deleteWikiArticle: Scalars['Boolean']['output'];
  login: User;
  logout: Scalars['Boolean']['output'];
  moveBookBlock: BookBlockMove;
  moveBookImage: BookChapter;
  moveBookParagraphs: BookChapter;
  oauthLogin: User;
  passkeyLogin: User;
  passkeyLoginOptions: Scalars['Any']['output'];
  passkeyRegister: UserPasskey;
  passkeyRegistrationOptions: Scalars['Any']['output'];
  placeBookBlock: BookBlockMove;
  register: Scalars['Boolean']['output'];
  reorderEntityImages: Scalars['Boolean']['output'];
  requestPasswordReset: Scalars['Boolean']['output'];
  resetPassword: Scalars['Boolean']['output'];
  setBookImageSide: BookChapter;
  setCommentsBlocked: Scalars['Boolean']['output'];
  unlinkIdentity: Scalars['Boolean']['output'];
  updateBook: Book;
  updateBookBlock: BookChapter;
  updateBookChapterToc: BookChapter;
  updateBookImage: BookChapter;
  updateBookParagraph: BookChapter;
  updateCharacterSheet: CharacterSheet;
  updateClass: Class;
  updateComment: Comment;
  updateFeat: Feat;
  updateFeature: Feature;
  updateGlossaryItem: GlossaryItem;
  updateImage: Image;
  updateItem: Item;
  updateMapGeometry: Scalars['Boolean']['output'];
  updateMapLabel: MapLabel;
  updateMonster: Monster;
  updateMonsterDescription?: Maybe<Monster>;
  updateMonsterGroup?: Maybe<MonsterGroup>;
  updateMonsterTrait: MonsterTrait;
  updateOrigin: Origin;
  updateSpecie: Specie;
  updateSpell: Spell;
  updateSubClass: SubClass;
  updateWikiArticle: WikiArticle;
};


export type MutationaddBookBlockArgs = {
  block: Scalars['String']['input'];
  chapterId: Scalars['String']['input'];
  href?: InputMaybe<Scalars['String']['input']>;
  inside?: InputMaybe<Scalars['Boolean']['input']>;
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type MutationaddBookParagraphArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  chapterId: Scalars['String']['input'];
  level?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt: Scalars['DateTimeISO']['input'];
};


export type MutationaddEntityImageArgs = {
  credits?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  height: Scalars['Int']['input'];
  path: Scalars['String']['input'];
  target: ImageTarget;
  targetId: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};


export type MutationcreateCharacterSheetArgs = {
  data: Scalars['Any']['input'];
};


export type MutationcreateClassArgs = {
  class: ClassInput;
};


export type MutationcreateCommentArgs = {
  parentId?: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['String']['input'];
  targetType: CommentTargetType;
  text: Scalars['String']['input'];
};


export type MutationcreateMapLabelArgs = {
  label: MapLabelCreateInput;
  mapId: Scalars['String']['input'];
};


export type MutationcreateSpellArgs = {
  spell: SpellInput;
};


export type MutationcreateWikiArticleArgs = {
  id: Scalars['String']['input'];
  wikiArticle: WikiArticleInput;
};


export type MutationdeleteBookBlockArgs = {
  block: Scalars['String']['input'];
  chapterId: Scalars['String']['input'];
};


export type MutationdeleteBookParagraphsArgs = {
  chapterId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
  updatedAt: Scalars['DateTimeISO']['input'];
};


export type MutationdeleteCharacterSheetArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteCommentArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteEntityImageArgs = {
  imageId: Scalars['String']['input'];
  target: ImageTarget;
  targetId: Scalars['String']['input'];
};


export type MutationdeleteMapLabelArgs = {
  id: Scalars['Int']['input'];
};


export type MutationdeletePasskeyArgs = {
  id: Scalars['String']['input'];
};


export type MutationdeleteWikiArticleArgs = {
  id: Scalars['String']['input'];
};


export type MutationloginArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  remember?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationmoveBookBlockArgs = {
  block: Scalars['String']['input'];
  chapterId: Scalars['String']['input'];
  direction: Scalars['Int']['input'];
};


export type MutationmoveBookImageArgs = {
  chapterId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  line: Scalars['Int']['input'];
  target: Scalars['String']['input'];
  updatedAt: Scalars['DateTimeISO']['input'];
};


export type MutationmoveBookParagraphsArgs = {
  after: Scalars['Boolean']['input'];
  chapterId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']>;
  target: Scalars['String']['input'];
  updatedAt: Scalars['DateTimeISO']['input'];
};


export type MutationoauthLoginArgs = {
  code: Scalars['String']['input'];
  provider: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


export type MutationpasskeyLoginArgs = {
  response: Scalars['Any']['input'];
};


export type MutationpasskeyRegisterArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  response: Scalars['Any']['input'];
};


export type MutationplaceBookBlockArgs = {
  after?: InputMaybe<Scalars['Boolean']['input']>;
  block: Scalars['String']['input'];
  chapterId: Scalars['String']['input'];
  target: Scalars['String']['input'];
};


export type MutationregisterArgs = {
  user: UserInput;
};


export type MutationreorderEntityImagesArgs = {
  imageIds: Array<Scalars['String']['input']>;
  target: ImageTarget;
  targetId: Scalars['String']['input'];
};


export type MutationrequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationresetPasswordArgs = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationsetBookImageSideArgs = {
  block: Scalars['String']['input'];
  chapterId: Scalars['String']['input'];
  side?: InputMaybe<Scalars['String']['input']>;
};


export type MutationsetCommentsBlockedArgs = {
  blocked: Scalars['Boolean']['input'];
  userId: Scalars['String']['input'];
};


export type MutationunlinkIdentityArgs = {
  id: Scalars['String']['input'];
};


export type MutationupdateBookArgs = {
  book: BookInput;
  id: Scalars['String']['input'];
};


export type MutationupdateBookBlockArgs = {
  block: Scalars['String']['input'];
  chapterId: Scalars['String']['input'];
  href?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  side?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};


export type MutationupdateBookChapterTocArgs = {
  chapterId: Scalars['String']['input'];
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationupdateBookImageArgs = {
  author?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  chapterId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  side?: InputMaybe<Scalars['String']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['DateTimeISO']['input'];
};


export type MutationupdateBookParagraphArgs = {
  chapterId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  level?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  title: Scalars['String']['input'];
  updatedAt: Scalars['DateTimeISO']['input'];
};


export type MutationupdateCharacterSheetArgs = {
  data: Scalars['Any']['input'];
  id: Scalars['String']['input'];
};


export type MutationupdateClassArgs = {
  class: ClassInput;
  id: Scalars['String']['input'];
};


export type MutationupdateCommentArgs = {
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type MutationupdateFeatArgs = {
  feat: FeatInput;
  id: Scalars['String']['input'];
};


export type MutationupdateFeatureArgs = {
  feature: FeatureInput;
  id: Scalars['String']['input'];
};


export type MutationupdateGlossaryItemArgs = {
  glossaryItem: GlossaryItemInput;
  id: Scalars['String']['input'];
};


export type MutationupdateImageArgs = {
  credits?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  originDescription?: InputMaybe<Scalars['String']['input']>;
};


export type MutationupdateItemArgs = {
  id: Scalars['String']['input'];
  item: ItemInput;
};


export type MutationupdateMapGeometryArgs = {
  labels?: InputMaybe<Array<MapLabelGeometryInput>>;
  mapId: Scalars['String']['input'];
  paths?: InputMaybe<Array<MapPathGeometryInput>>;
};


export type MutationupdateMapLabelArgs = {
  id: Scalars['Int']['input'];
  label: MapLabelInput;
};


export type MutationupdateMonsterArgs = {
  id: Scalars['String']['input'];
  monster: MonsterInput;
};


export type MutationupdateMonsterDescriptionArgs = {
  id: Scalars['String']['input'];
  monster: MonsterDescriptionInput;
};


export type MutationupdateMonsterGroupArgs = {
  group: MonsterGroupInput;
  id: Scalars['String']['input'];
};


export type MutationupdateMonsterTraitArgs = {
  id: Scalars['String']['input'];
  trait: MonsterTraitInput;
};


export type MutationupdateOriginArgs = {
  id: Scalars['String']['input'];
  origin: OriginInput;
};


export type MutationupdateSpecieArgs = {
  id: Scalars['String']['input'];
  specie: SpecieInput;
};


export type MutationupdateSpellArgs = {
  id: Scalars['String']['input'];
  spell: SpellInput;
};


export type MutationupdateSubClassArgs = {
  id: Scalars['String']['input'];
  subClass: SubClassInput;
};


export type MutationupdateWikiArticleArgs = {
  id: Scalars['String']['input'];
  wikiArticle: WikiArticleInput;
};

export type NameGroup = {
  code: Scalars['String']['output'];
  familyFirst?: Maybe<Scalars['Boolean']['output']>;
  items: Array<Scalars['String']['output']>;
  noteLabel?: Maybe<Scalars['String']['output']>;
  people?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type NameSet = {
  genitive: Scalars['String']['output'];
  groups: Array<NameGroup>;
  id: Scalars['String']['output'];
  order: Scalars['Float']['output'];
  source?: Maybe<Array<Source>>;
  specieId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type Origin = {
  abilities: Scalars['String']['output'];
  alternativeTitles?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  equipment: Scalars['String']['output'];
  feat: Scalars['String']['output'];
  featCategory?: Maybe<Scalars['String']['output']>;
  featId?: Maybe<Scalars['String']['output']>;
  featVariant?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<Image>>;
  instruments: Scalars['String']['output'];
  originalTitle: Scalars['String']['output'];
  skills: Scalars['String']['output'];
  source?: Maybe<Array<Source>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

/** Фильтр списка предысторий */
export type OriginFilterInput = {
  /** Все выбранные характеристики должны повышаться */
  abilities?: InputMaybe<Array<Ability>>;
  sources?: InputMaybe<Array<SourceBook>>;
};

export type OriginInput = {
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  equipment?: InputMaybe<Scalars['String']['input']>;
  feat?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  instruments?: InputMaybe<Scalars['String']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  proficiencies?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<SourceInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum PoisonType {
  Contact = 'Contact',
  Ingested = 'Ingested',
  Inhaled = 'Inhaled',
  Injury = 'Injury'
}

export type Query = {
  adminComments: AdminCommentsPage;
  blockedCommentAuthors: Array<Scalars['String']['output']>;
  book?: Maybe<Book>;
  bookBlock: BookBlockContent;
  bookChapter?: Maybe<BookChapter>;
  bookChapters: Array<BookChapter>;
  bookParagraph: BookParagraphForm;
  books: Array<Book>;
  characterSheet: CharacterSheet;
  characterSheets: Array<CharacterSheet>;
  class: Class;
  classes: Array<Class>;
  commentActivity: Array<CommentActivity>;
  comments: Array<Comment>;
  currentUser?: Maybe<User>;
  dayCard?: Maybe<DayCard>;
  feat: Feat;
  feats: Array<Feat>;
  feature: Feature;
  features: Array<Feature>;
  featuresByType: Array<Feature>;
  findClasses: Array<Class>;
  findFeat: Array<Feat>;
  findFeatures: Array<Feature>;
  findGlossaryItems: Array<GlossaryItem>;
  findItems: Array<Item>;
  findMonsters: Array<Monster>;
  findOrigins: Array<Origin>;
  findSpecies: Array<Specie>;
  findSpells: Array<Spell>;
  gameMap?: Maybe<GameMap>;
  gameMaps: Array<GameMap>;
  glossaryItem: GlossaryItem;
  glossaryItems: Array<GlossaryItem>;
  item: Item;
  items: Array<Item>;
  itemsByIds: Array<Item>;
  languages: Array<Language>;
  monster: Monster;
  monsterTrait: MonsterTrait;
  monsters: Array<Monster>;
  myIdentities: Array<UserIdentity>;
  myPasskeys: Array<UserPasskey>;
  nameSet?: Maybe<NameSet>;
  nameSets: Array<NameSet>;
  oauthProviders: Array<Scalars['String']['output']>;
  oauthUrl: Scalars['String']['output'];
  origin: Origin;
  origins: Array<Origin>;
  /** Поиск по всем разделам. Группы по разделам в порядке релевантности, в группе — лучшие limit записей */
  search: Array<SearchGroup>;
  /** То же, что search, но с запросом в другой раскладке, если выдача найдена по нему */
  searchResult: SearchResponse;
  specie: Specie;
  species: Array<Specie>;
  spell: Spell;
  spells: Array<Spell>;
  spellsWithClasses: Array<Spell>;
  subClass: SubClass;
  wikiArticle: WikiArticle;
  wikiArticles: Array<WikiArticle>;
};


export type QueryadminCommentsArgs = {
  limit?: Scalars['Int']['input'];
  offset?: Scalars['Int']['input'];
};


export type QueryblockedCommentAuthorsArgs = {
  targetId: Scalars['String']['input'];
  targetType: CommentTargetType;
};


export type QuerybookArgs = {
  id: Scalars['String']['input'];
};


export type QuerybookBlockArgs = {
  block: Scalars['String']['input'];
  chapterId: Scalars['String']['input'];
};


export type QuerybookChapterArgs = {
  id: Scalars['String']['input'];
};


export type QuerybookChaptersArgs = {
  bookId: Scalars['String']['input'];
};


export type QuerybookParagraphArgs = {
  chapterId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type QuerybooksArgs = {
  available?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerycharacterSheetArgs = {
  id: Scalars['String']['input'];
};


export type QueryclassArgs = {
  id: Scalars['String']['input'];
  level?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryclassesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QuerycommentsArgs = {
  targetId: Scalars['String']['input'];
  targetType: CommentTargetType;
};


export type QuerydayCardArgs = {
  date: Scalars['String']['input'];
};


export type QueryfeatArgs = {
  id: Scalars['String']['input'];
};


export type QueryfeatsArgs = {
  filters?: InputMaybe<FeatFilterInput>;
};


export type QueryfeatureArgs = {
  id: Scalars['String']['input'];
};


export type QueryfeaturesByTypeArgs = {
  type: Scalars['String']['input'];
};


export type QueryfindClassesArgs = {
  text: Scalars['String']['input'];
};


export type QueryfindFeatArgs = {
  text: Scalars['String']['input'];
};


export type QueryfindFeaturesArgs = {
  text: Scalars['String']['input'];
};


export type QueryfindGlossaryItemsArgs = {
  text: Scalars['String']['input'];
};


export type QueryfindItemsArgs = {
  text: Scalars['String']['input'];
};


export type QueryfindMonstersArgs = {
  text: Scalars['String']['input'];
};


export type QueryfindOriginsArgs = {
  text: Scalars['String']['input'];
};


export type QueryfindSpeciesArgs = {
  text: Scalars['String']['input'];
};


export type QueryfindSpellsArgs = {
  text: Scalars['String']['input'];
};


export type QuerygameMapArgs = {
  id: Scalars['String']['input'];
};


export type QueryglossaryItemArgs = {
  id: Scalars['String']['input'];
};


export type QueryitemArgs = {
  id: Scalars['String']['input'];
};


export type QueryitemsArgs = {
  filters?: InputMaybe<ItemFilterInput>;
  types?: InputMaybe<Array<ItemType>>;
  withoutBaseItem?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryitemsByIdsArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type QuerylanguagesArgs = {
  exotic?: InputMaybe<Scalars['Boolean']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
  standard?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QuerymonsterArgs = {
  id: Scalars['String']['input'];
};


export type QuerymonsterTraitArgs = {
  id: Scalars['String']['input'];
};


export type QuerymonstersArgs = {
  filters?: InputMaybe<MonsterFilterInput>;
};


export type QuerynameSetArgs = {
  id: Scalars['String']['input'];
};


export type QueryoauthUrlArgs = {
  provider: Scalars['String']['input'];
};


export type QueryoriginArgs = {
  id: Scalars['String']['input'];
};


export type QueryoriginsArgs = {
  filters?: InputMaybe<OriginFilterInput>;
};


export type QuerysearchArgs = {
  limit?: Scalars['Int']['input'];
  prefer?: InputMaybe<SearchSection>;
  query: Scalars['String']['input'];
  section?: InputMaybe<SearchSection>;
};


export type QuerysearchResultArgs = {
  limit?: Scalars['Int']['input'];
  prefer?: InputMaybe<SearchSection>;
  query: Scalars['String']['input'];
  section?: InputMaybe<SearchSection>;
};


export type QueryspecieArgs = {
  id: Scalars['String']['input'];
};


export type QueryspellArgs = {
  id: Scalars['String']['input'];
};


export type QueryspellsArgs = {
  filters?: InputMaybe<SpellFilterInput>;
};


export type QuerysubClassArgs = {
  id: Scalars['String']['input'];
};


export type QuerywikiArticleArgs = {
  id: Scalars['String']['input'];
};


export type QuerywikiArticlesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  tag?: InputMaybe<Scalars['String']['input']>;
};

export type RaceSize = {
  category: Size;
  tallFrom: Scalars['Int']['output'];
  tallTo: Scalars['Int']['output'];
};

export enum RangeType {
  cone = 'cone',
  cube = 'cube',
  emanation = 'emanation',
  hemisphere = 'hemisphere',
  line = 'line',
  point = 'point',
  radius = 'radius',
  special = 'special',
  sphere = 'sphere'
}

export enum RechargeTime {
  Dawn = 'Dawn',
  Dusk = 'Dusk',
  Midnight = 'Midnight',
  Special = 'Special'
}

export enum SearchEntity {
  BookChapter = 'BookChapter',
  BookSection = 'BookSection',
  Class = 'Class',
  Feat = 'Feat',
  Feature = 'Feature',
  GlossaryItem = 'GlossaryItem',
  Item = 'Item',
  Monster = 'Monster',
  NameSet = 'NameSet',
  Origin = 'Origin',
  Page = 'Page',
  Specie = 'Specie',
  Spell = 'Spell',
  SubClass = 'SubClass',
  WikiArticle = 'WikiArticle'
}

/** Результаты одного раздела */
export type SearchGroup = {
  hits: Array<SearchHit>;
  section: SearchSection;
  /** Сколько всего нашлось в разделе */
  total: Scalars['Int']['output'];
};

/** Найденная запись */
export type SearchHit = {
  /** Альтернативное название, если запись нашлась по нему, а не по основному */
  alternativeTitle?: Maybe<Scalars['String']['output']>;
  bookId?: Maybe<Scalars['String']['output']>;
  /** Глава книги, в которой нашёлся раздел */
  chapterId?: Maybe<Scalars['String']['output']>;
  classId?: Maybe<Scalars['String']['output']>;
  entity: SearchEntity;
  /** Тип особенности без владельца: воззвание, маневр… */
  featureType?: Maybe<FeatureType>;
  /** Слова в названиях и фрагменте, совпавшие с запросом, — для подсветки */
  highlights: Array<Scalars['String']['output']>;
  /** Готовый адрес страницы — у записей-страниц и фильтров списков */
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  originalTitle?: Maybe<Scalars['String']['output']>;
  /** Фрагмент описания с совпадением, без разметки */
  snippet?: Maybe<Scalars['String']['output']>;
  specieId?: Maybe<Scalars['String']['output']>;
  subClassId?: Maybe<Scalars['String']['output']>;
  /** Что это и чьё: «Заклинание 3-го круга», «Воин, 2-й уровень» */
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Выдача поиска вместе с запросом, по которому она найдена */
export type SearchResponse = {
  /** Запрос в другой раскладке, если по исходному ничего не нашлось, а по нему нашлось: «jutyysq» → «огненный» */
  correctedQuery?: Maybe<Scalars['String']['output']>;
  groups: Array<SearchGroup>;
  /** Запрос, как его ввёл пользователь */
  query: Scalars['String']['output'];
};

/** Раздел сайта, по которому сгруппирована выдача */
export enum SearchSection {
  books = 'books',
  classes = 'classes',
  feats = 'feats',
  glossary = 'glossary',
  items = 'items',
  monsters = 'monsters',
  names = 'names',
  origins = 'origins',
  pages = 'pages',
  species = 'species',
  spells = 'spells',
  wiki = 'wiki'
}

export type SimpleItem = {
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum Size {
  Gargantuan = 'Gargantuan',
  Huge = 'Huge',
  Large = 'Large',
  Medium = 'Medium',
  Small = 'Small',
  Tiny = 'Tiny'
}

export type Source = {
  book: Scalars['String']['output'];
  page?: Maybe<Scalars['Int']['output']>;
};

export enum SourceBook {
  AU = 'AU',
  DDBD = 'DDBD',
  DMG = 'DMG',
  FRAiF = 'FRAiF',
  FRHoF = 'FRHoF',
  MM = 'MM',
  PHB = 'PHB',
  PaBTSO = 'PaBTSO',
  SCAG = 'SCAG',
  ToD = 'ToD',
  XDMG = 'XDMG',
  XGE = 'XGE',
  XMM = 'XMM',
  XPHB = 'XPHB'
}

export type SourceInput = {
  book: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type Specie = {
  alternativeTitles?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  features?: Maybe<Array<Feature>>;
  featuresDescription?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<Image>>;
  originalTitle: Scalars['String']['output'];
  props?: Maybe<Scalars['Any']['output']>;
  sizes: Array<RaceSize>;
  source?: Maybe<Array<Source>>;
  speed: Scalars['Float']['output'];
  spells?: Maybe<Array<Spell>>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type SpecieInput = {
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<FeatureInput>>;
  featuresDescription?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<SourceInput>>;
  speed?: InputMaybe<Scalars['Float']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Spell = {
  alternativeTitles?: Maybe<Array<Scalars['String']['output']>>;
  attackType?: Maybe<AttackType>;
  basicRules?: Maybe<Scalars['Boolean']['output']>;
  cardDescription?: Maybe<Scalars['String']['output']>;
  choose?: Maybe<Array<Scalars['Any']['output']>>;
  circleSpell?: Maybe<Scalars['Boolean']['output']>;
  classes?: Maybe<Array<Class>>;
  components: SpellComponent;
  condition?: Maybe<Array<ConditionType>>;
  damage?: Maybe<Array<DamageType>>;
  description?: Maybe<Scalars['String']['output']>;
  duration: Array<SpellDuration>;
  feats?: Maybe<Array<Feat>>;
  features?: Maybe<Array<Feature>>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<Image>>;
  legacySpell?: Maybe<Spell>;
  legacySpellId?: Maybe<Scalars['String']['output']>;
  level: Scalars['Float']['output'];
  originalTitle: Scalars['String']['output'];
  props?: Maybe<Scalars['Any']['output']>;
  range: SpellRange;
  ritual?: Maybe<Scalars['Boolean']['output']>;
  savingThrow?: Maybe<Array<Ability>>;
  scalingLevelDice?: Maybe<Array<Scalars['Any']['output']>>;
  school: SpellSchool;
  source?: Maybe<Array<Source>>;
  species?: Maybe<Array<Specie>>;
  subClasses?: Maybe<Array<SubClass>>;
  time: Array<SpellTime>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type SpellComponent = {
  m?: Maybe<SpellMaterialComponent>;
  s?: Maybe<Scalars['Boolean']['output']>;
  v?: Maybe<Scalars['Boolean']['output']>;
};

export type SpellDistance = {
  amount?: Maybe<Scalars['Int']['output']>;
  type: DistanceType;
};

export type SpellDuration = {
  amount?: Maybe<Scalars['Int']['output']>;
  concentration?: Maybe<Scalars['Boolean']['output']>;
  ends?: Maybe<Array<Scalars['String']['output']>>;
  type: DurationType;
  units?: Maybe<DurationUnit>;
  upTo?: Maybe<Scalars['Boolean']['output']>;
};

/** Фильтр списка заклинаний; внутри одного поля значения объединяются через «или» */
export type SpellFilterInput = {
  /** id классов */
  classes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** v, s, m — все выбранные компоненты обязательны */
  components?: InputMaybe<Array<Scalars['String']['input']>>;
  concentration?: InputMaybe<Scalars['Boolean']['input']>;
  /** null — заклинания без урона */
  damageTypes?: InputMaybe<Array<InputMaybe<DamageType>>>;
  levels?: InputMaybe<Array<Scalars['Int']['input']>>;
  ritual?: InputMaybe<Scalars['Boolean']['input']>;
  schools?: InputMaybe<Array<SpellSchool>>;
  sources?: InputMaybe<Array<SourceBook>>;
  /** action, bonus, reaction, 1m, 10m, 1h, 8h, 12h, 24h */
  times?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SpellInput = {
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  level?: InputMaybe<Scalars['Float']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  school?: InputMaybe<SpellSchool>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type SpellMaterialComponent = {
  coast?: Maybe<Scalars['Int']['output']>;
  consume?: Maybe<Scalars['Any']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type SpellRange = {
  distance?: Maybe<SpellDistance>;
  type: RangeType;
};

export enum SpellSchool {
  Abjuration = 'Abjuration',
  Conjuration = 'Conjuration',
  Divination = 'Divination',
  Enchantment = 'Enchantment',
  Evocation = 'Evocation',
  Illusion = 'Illusion',
  Necromancy = 'Necromancy',
  Transmutation = 'Transmutation'
}

export type SpellTime = {
  condition?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  unit: CastingTimeUnit;
};

export type SubClass = {
  alternativeTitles?: Maybe<Array<Scalars['String']['output']>>;
  caption: Scalars['String']['output'];
  class: Class;
  classId: Scalars['String']['output'];
  classTitle: Scalars['String']['output'];
  description: Scalars['String']['output'];
  features: Array<Feature>;
  id: Scalars['String']['output'];
  images?: Maybe<Array<Image>>;
  order?: Maybe<Scalars['Float']['output']>;
  originalTitle: Scalars['String']['output'];
  props?: Maybe<Scalars['Any']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Array<Source>>;
  spells?: Maybe<Array<Spell>>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type SubClassInput = {
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  caption?: InputMaybe<Scalars['String']['input']>;
  classId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  features?: InputMaybe<Array<FeatureInput>>;
  id?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<SourceInput>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type TraitSpell = {
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  originalComment?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type TraitSpellLine = {
  isEach: Scalars['Boolean']['output'];
  slots: Scalars['String']['output'];
  spells: Array<TraitSpell>;
};

export enum TraitType {
  Action = 'Action',
  BonusAction = 'BonusAction',
  Feature = 'Feature',
  Lair = 'Lair',
  LegendaryAction = 'LegendaryAction',
  Reaction = 'Reaction'
}

export type User = {
  createdAt: Scalars['DateTimeISO']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isAdmin: Scalars['Boolean']['output'];
  isCommentsBlocked: Scalars['Boolean']['output'];
  isDeleted: Scalars['Boolean']['output'];
  loginAt?: Maybe<Scalars['DateTimeISO']['output']>;
  nickname: Scalars['String']['output'];
  password: Scalars['String']['output'];
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type UserIdentity = {
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  provider: Scalars['String']['output'];
};

export type UserInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
};

export type UserPasskey = {
  createdAt: Scalars['DateTimeISO']['output'];
  id: Scalars['String']['output'];
  lastUsedAt?: Maybe<Scalars['DateTimeISO']['output']>;
  name: Scalars['String']['output'];
};

export enum WeaponCategory {
  Martial = 'Martial',
  Simple = 'Simple'
}

export enum WeaponMastery {
  Cleave = 'Cleave',
  Graze = 'Graze',
  Nick = 'Nick',
  Push = 'Push',
  Sap = 'Sap',
  Slow = 'Slow',
  Topple = 'Topple',
  Vex = 'Vex'
}

export enum WeaponProperty {
  Ammunition = 'Ammunition',
  AmmunitionFirearms = 'AmmunitionFirearms',
  BurstFire = 'BurstFire',
  Finesse = 'Finesse',
  Heavy = 'Heavy',
  Light = 'Light',
  Loading = 'Loading',
  Reach = 'Reach',
  Reload = 'Reload',
  Special = 'Special',
  Thrown = 'Thrown',
  TwoHand = 'TwoHand',
  TwoHandUnlessMounted = 'TwoHandUnlessMounted',
  Versatile = 'Versatile'
}

export type WikiArticle = {
  alternativeTitles?: Maybe<Array<Scalars['String']['output']>>;
  ancestors: Array<WikiArticle>;
  children: Array<WikiArticle>;
  description?: Maybe<Scalars['String']['output']>;
  gameMap?: Maybe<GameMap>;
  id: Scalars['String']['output'];
  infobox?: Maybe<Scalars['Any']['output']>;
  memberOf: Array<WikiArticle>;
  members: Array<WikiArticle>;
  /** Списки статей того же типа в конце статьи: государства Фейруна, города региона, улицы и районы города, все боги */
  navboxes: Array<WikiNavbox>;
  originalTitle: Scalars['String']['output'];
  parentId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Array<Source>>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  title: Scalars['String']['output'];
  types?: Maybe<Array<Scalars['String']['output']>>;
  updatedAt: Scalars['DateTimeISO']['output'];
};

export type WikiArticleInput = {
  alternativeTitles?: InputMaybe<Array<Scalars['String']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  infobox?: InputMaybe<Scalars['Any']['input']>;
  originalTitle?: InputMaybe<Scalars['String']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Array<SourceInput>>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Список статей одного типа в пределах области: государства Фейруна, улицы Вотердипа */
export type WikiNavbox = {
  articles: Array<WikiArticle>;
  /** Область: континент, регион или город; пусто — все статьи типа */
  scope?: Maybe<WikiArticle>;
  /** Тип статей в списке: realm, city, street… */
  type: Scalars['String']['output'];
};

export type AddBookBlockMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  block: Scalars['String']['input'];
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  text: Scalars['String']['input'];
  href?: InputMaybe<Scalars['String']['input']>;
  inside?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AddBookBlockMutation = { addBookBlock: { block: string, chapter: { id: string, title: string, headings?: any | undefined, content?: any | undefined } } };

export type AddBookParagraphMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  level?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  updatedAt: Scalars['DateTimeISO']['input'];
}>;


export type AddBookParagraphMutation = { addBookParagraph: { paragraph: string, chapter: { id: string, updatedAt: string, headings?: any | undefined, content?: any | undefined } } };

export type BookBlockQueryVariables = Exact<{
  chapterId: Scalars['String']['input'];
  block: Scalars['String']['input'];
}>;


export type BookBlockQuery = { bookBlock: { kind: string, name: string, text: string, href: string, side: string, portrait: boolean } };

export type BookChapterQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BookChapterQuery = { bookChapter?: { id: string, bookId: string, order: number, title: string, label?: string | undefined, part?: string | undefined, page?: number | undefined, endPage?: number | undefined, headings?: any | undefined, content?: any | undefined, updatedAt: string } | undefined };

export type BookParagraphQueryVariables = Exact<{
  chapterId: Scalars['String']['input'];
  id: Scalars['String']['input'];
}>;


export type BookParagraphQuery = { bookParagraph: { id: string, title: string, level?: number | undefined, text: string } };

export type BookQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type BookQuery = { book?: { id: string, title: string, originalTitle: string, cover?: string | undefined, description?: string | undefined, group?: string | undefined, level?: string | undefined, storyline?: string | undefined, publishedAt?: string | undefined, chapters?: Array<{ id: string, order: number, title: string, label?: string | undefined, part?: string | undefined, page?: number | undefined, endPage?: number | undefined, headings?: any | undefined, toc?: any | undefined, customToc: boolean }> | undefined } | undefined };

export type BooksQueryVariables = Exact<{
  available?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BooksQuery = { books: Array<{ id: string, title: string, originalTitle: string, cover?: string | undefined, description?: string | undefined, group?: string | undefined, level?: string | undefined, storyline?: string | undefined, publishedAt?: string | undefined }> };

export type DeleteBookBlockMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  block: Scalars['String']['input'];
}>;


export type DeleteBookBlockMutation = { deleteBookBlock: { id: string, title: string, headings?: any | undefined, content?: any | undefined } };

export type DeleteBookParagraphsMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  updatedAt: Scalars['DateTimeISO']['input'];
}>;


export type DeleteBookParagraphsMutation = { deleteBookParagraphs: { id: string, updatedAt: string, headings?: any | undefined, content?: any | undefined } };

export type MoveBookBlockMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  block: Scalars['String']['input'];
  direction: Scalars['Int']['input'];
}>;


export type MoveBookBlockMutation = { moveBookBlock: { block: string, chapter: { id: string, title: string, headings?: any | undefined, content?: any | undefined } } };

export type MoveBookImageMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  target: Scalars['String']['input'];
  line: Scalars['Int']['input'];
  updatedAt: Scalars['DateTimeISO']['input'];
}>;


export type MoveBookImageMutation = { moveBookImage: { id: string, updatedAt: string, headings?: any | undefined, content?: any | undefined } };

export type MoveBookParagraphsMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  target: Scalars['String']['input'];
  after: Scalars['Boolean']['input'];
  updatedAt: Scalars['DateTimeISO']['input'];
}>;


export type MoveBookParagraphsMutation = { moveBookParagraphs: { id: string, updatedAt: string, headings?: any | undefined, content?: any | undefined } };

export type PlaceBookBlockMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  block: Scalars['String']['input'];
  target: Scalars['String']['input'];
  after?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type PlaceBookBlockMutation = { placeBookBlock: { block: string, chapter: { id: string, title: string, headings?: any | undefined, content?: any | undefined } } };

export type SetBookImageSideMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  block: Scalars['String']['input'];
  side?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetBookImageSideMutation = { setBookImageSide: { id: string, title: string, headings?: any | undefined, content?: any | undefined } };

export type UpdateBookBlockMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  block: Scalars['String']['input'];
  name: Scalars['String']['input'];
  text: Scalars['String']['input'];
  href?: InputMaybe<Scalars['String']['input']>;
  side?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateBookBlockMutation = { updateBookBlock: { id: string, title: string, headings?: any | undefined, content?: any | undefined } };

export type UpdateBookChapterTocMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type UpdateBookChapterTocMutation = { updateBookChapterToc: { id: string, toc?: any | undefined, customToc: boolean, updatedAt: string } };

export type UpdateBookImageMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  caption?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  src?: InputMaybe<Scalars['String']['input']>;
  side?: InputMaybe<Scalars['String']['input']>;
  updatedAt: Scalars['DateTimeISO']['input'];
}>;


export type UpdateBookImageMutation = { updateBookImage: { id: string, updatedAt: string, headings?: any | undefined, content?: any | undefined } };

export type UpdateBookParagraphMutationVariables = Exact<{
  chapterId: Scalars['String']['input'];
  id: Scalars['String']['input'];
  title: Scalars['String']['input'];
  level?: InputMaybe<Scalars['Int']['input']>;
  text: Scalars['String']['input'];
  updatedAt: Scalars['DateTimeISO']['input'];
}>;


export type UpdateBookParagraphMutation = { updateBookParagraph: { id: string, updatedAt: string, headings?: any | undefined, content?: any | undefined } };

export type UpdateBookMutationVariables = Exact<{
  id: Scalars['String']['input'];
  book: BookInput;
}>;


export type UpdateBookMutation = { updateBook: { id: string, cover?: string | undefined, description?: string | undefined } };

export type CharacterCatalogQueryVariables = Exact<{
  itemTypes?: InputMaybe<Array<ItemType> | ItemType>;
}>;


export type CharacterCatalogQuery = { classes: Array<{ id: string, title: string, equipment: string, hitDie: number, saves: Array<Ability>, props?: any | undefined, choose?: any | undefined, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, cases: { genitive: string }, subClasses?: Array<{ id: string, title: string }> | undefined }>, species: Array<{ id: string, title: string, speed: number, sizes: Array<{ category: Size }> }>, origins: Array<{ id: string, title: string, equipment: string, abilities: string, skills: string, instruments: string, featId?: string | undefined, featVariant?: string | undefined, featCategory?: string | undefined }>, feats: Array<{ id: string, title: string, category: FeatCategory, variantKey?: string | undefined, repeatable?: boolean | undefined }>, features: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }>, spellsWithClasses: Array<{ id: string, title: string, level: number, school: SpellSchool, ritual?: boolean | undefined, attackType?: AttackType | undefined, damage?: Array<DamageType> | undefined, savingThrow?: Array<Ability> | undefined, props?: any | undefined, choose?: Array<any> | undefined, time: Array<{ number: number, unit: CastingTimeUnit, condition?: string | undefined }>, duration: Array<{ type: DurationType, units?: DurationUnit | undefined, concentration?: boolean | undefined, upTo?: boolean | undefined, amount?: number | undefined, ends?: Array<string> | undefined }>, range: { type: RangeType, distance?: { type: DistanceType, amount?: number | undefined } | undefined }, components: { v?: boolean | undefined, s?: boolean | undefined, m?: { text?: string | undefined } | undefined }, classes?: Array<{ id: string }> | undefined }>, items: Array<{ id: string, title: string, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, weaponCategory?: WeaponCategory | undefined, weaponMastery?: Array<WeaponMastery> | undefined }>, languages: Array<{ id: string, title: string, standard?: boolean | undefined, exotic?: boolean | undefined }> };

export type CharacterItemSearchQueryVariables = Exact<{ [key: string]: never; }>;


export type CharacterItemSearchQuery = { items: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, parentId?: string | undefined, rarity: ItemRarity, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, choose?: Array<any> | undefined }> };

export type CharacterItemsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type CharacterItemsQuery = { itemsByIds: Array<{ description?: string | undefined, id: string, title: string, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, rarity: ItemRarity, weaponCategory?: WeaponCategory | undefined, weaponProperty?: Array<WeaponProperty> | undefined, weaponMastery?: Array<WeaponMastery> | undefined, dmg1?: string | undefined, dmg2?: string | undefined, dmgType?: DamageType | undefined, range?: string | undefined, weight?: number | undefined, price?: number | undefined, ac?: number | undefined, strength?: number | undefined, stealth?: boolean | undefined, reqAttune?: boolean | undefined, props?: any | undefined, choose?: Array<any> | undefined, parentItem?: { id: string, description?: string | undefined } | undefined, baseItem?: { id: string, title: string, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, rarity: ItemRarity, weaponCategory?: WeaponCategory | undefined, weaponProperty?: Array<WeaponProperty> | undefined, weaponMastery?: Array<WeaponMastery> | undefined, dmg1?: string | undefined, dmg2?: string | undefined, dmgType?: DamageType | undefined, range?: string | undefined, weight?: number | undefined, price?: number | undefined, ac?: number | undefined, strength?: number | undefined, stealth?: boolean | undefined, reqAttune?: boolean | undefined, props?: any | undefined, choose?: Array<any> | undefined } | undefined }> };

export type CharacterItemFragment = { id: string, title: string, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, rarity: ItemRarity, weaponCategory?: WeaponCategory | undefined, weaponProperty?: Array<WeaponProperty> | undefined, weaponMastery?: Array<WeaponMastery> | undefined, dmg1?: string | undefined, dmg2?: string | undefined, dmgType?: DamageType | undefined, range?: string | undefined, weight?: number | undefined, price?: number | undefined, ac?: number | undefined, strength?: number | undefined, stealth?: boolean | undefined, reqAttune?: boolean | undefined, props?: any | undefined, choose?: Array<any> | undefined };

export type CharacterSheetEntryFragment = { id: string, name: string, data: any, updatedAt: string };

export type CharacterSheetsQueryVariables = Exact<{ [key: string]: never; }>;


export type CharacterSheetsQuery = { characterSheets: Array<{ id: string, name: string, data: any, updatedAt: string }> };

export type CharacterSheetQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CharacterSheetQuery = { characterSheet: { id: string, name: string, data: any, updatedAt: string } };

export type CreateCharacterSheetMutationVariables = Exact<{
  data: Scalars['Any']['input'];
}>;


export type CreateCharacterSheetMutation = { createCharacterSheet: { id: string, name: string, data: any, updatedAt: string } };

export type UpdateCharacterSheetMutationVariables = Exact<{
  id: Scalars['String']['input'];
  data: Scalars['Any']['input'];
}>;


export type UpdateCharacterSheetMutation = { updateCharacterSheet: { id: string, name: string, updatedAt: string } };

export type DeleteCharacterSheetMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCharacterSheetMutation = { deleteCharacterSheet: boolean };

export type AboutClassQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AboutClassQuery = { class: { id: string, updatedAt: string, title: string, originalTitle: string, description: string, multiClassing: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, equipment: string, subClassDescription: string, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, trainingTable?: Array<Array<string | undefined> | undefined> | undefined, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, choose?: any | undefined, cases: { genitive: string }, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type ClassQueryVariables = Exact<{
  id: Scalars['String']['input'];
  level?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ClassQuery = { class: { id: string, updatedAt: string, title: string, originalTitle: string, description: string, multiClassing: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, equipment: string, subClassDescription: string, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, trainingTable?: Array<Array<string | undefined> | undefined> | undefined, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, choose?: any | undefined, features?: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, subClasses?: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, shortDescription?: string | undefined, classId: string, order?: number | undefined, props?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, cases: { genitive: string }, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type ClassFragment = { id: string, updatedAt: string, title: string, originalTitle: string, description: string, multiClassing: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, equipment: string, subClassDescription: string, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, trainingTable?: Array<Array<string | undefined> | undefined> | undefined, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, cases: { genitive: string }, source?: Array<{ book: string, page?: number | undefined }> | undefined, features?: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, subClasses?: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, shortDescription?: string | undefined, classId: string, order?: number | undefined, props?: any | undefined, caption: string, source?: Array<{ book: string, page?: number | undefined }> | undefined, features: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }>, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined }> | undefined, spells?: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, level: number, school: SpellSchool, damage?: Array<DamageType> | undefined, ritual?: boolean | undefined, attackType?: AttackType | undefined, basicRules?: boolean | undefined, components: { v?: boolean | undefined, s?: boolean | undefined, m?: { text?: string | undefined, consume?: any | undefined, coast?: number | undefined } | undefined }, time: Array<{ condition?: string | undefined, unit: CastingTimeUnit, number: number }>, range: { type: RangeType, distance?: { type: DistanceType, amount?: number | undefined } | undefined }, duration: Array<{ type: DurationType, units?: DurationUnit | undefined, concentration?: boolean | undefined, upTo?: boolean | undefined, amount?: number | undefined, ends?: Array<string> | undefined }>, source?: Array<{ book: string, page?: number | undefined }> | undefined, classes?: Array<{ id: string, title: string }> | undefined, feats?: Array<{ id: string, title: string }> | undefined, features?: Array<{ id: string, title: string, subClassId?: string | undefined, classId?: string | undefined, type?: FeatureType | undefined, subClass?: { classId: string } | undefined }> | undefined, subClasses?: Array<{ id: string, title: string, classId: string }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined };

export type FlatClassFragment = { id: string, updatedAt: string, title: string, originalTitle: string, description: string, multiClassing: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, equipment: string, subClassDescription: string, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, trainingTable?: Array<Array<string | undefined> | undefined> | undefined, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, choose?: any | undefined, cases: { genitive: string }, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined };

export type FeatureWithClassFragment = { id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, class?: { id: string, updatedAt: string, title: string, originalTitle: string, description: string, multiClassing: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, equipment: string, subClassDescription: string, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, trainingTable?: Array<Array<string | undefined> | undefined> | undefined, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, choose?: any | undefined, cases: { genitive: string }, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } | undefined };

export type SubClassFragment = { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, shortDescription?: string | undefined, classId: string, order?: number | undefined, props?: any | undefined, caption: string, source?: Array<{ book: string, page?: number | undefined }> | undefined, features: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }>, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined };

export type FlatSubClassFragment = { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, shortDescription?: string | undefined, classId: string, order?: number | undefined, props?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined };

export type ClassesByIdsQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ClassesByIdsQuery = { classes: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, description: string, multiClassing: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, equipment: string, subClassDescription: string, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, trainingTable?: Array<Array<string | undefined> | undefined> | undefined, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, choose?: any | undefined, features?: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, subClasses?: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, shortDescription?: string | undefined, classId: string, order?: number | undefined, props?: any | undefined, caption: string, source?: Array<{ book: string, page?: number | undefined }> | undefined, features: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }>, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined }> | undefined, cases: { genitive: string }, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined }> };

export type ClassesQueryVariables = Exact<{ [key: string]: never; }>;


export type ClassesQuery = { classes: Array<{ id: string, title: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, subClasses?: Array<{ id: string, title: string, classId: string }> | undefined }> };

export type CreateClassMutationVariables = Exact<{
  class: ClassInput;
}>;


export type CreateClassMutation = { createClass: { id: string, updatedAt: string, title: string, originalTitle: string, description: string, multiClassing: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, equipment: string, subClassDescription: string, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, trainingTable?: Array<Array<string | undefined> | undefined> | undefined, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, cases: { genitive: string }, source?: Array<{ book: string, page?: number | undefined }> | undefined, features?: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, subClasses?: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, shortDescription?: string | undefined, classId: string, order?: number | undefined, props?: any | undefined, caption: string, source?: Array<{ book: string, page?: number | undefined }> | undefined, features: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }>, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined }> | undefined, spells?: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, level: number, school: SpellSchool, damage?: Array<DamageType> | undefined, ritual?: boolean | undefined, attackType?: AttackType | undefined, basicRules?: boolean | undefined, components: { v?: boolean | undefined, s?: boolean | undefined, m?: { text?: string | undefined, consume?: any | undefined, coast?: number | undefined } | undefined }, time: Array<{ condition?: string | undefined, unit: CastingTimeUnit, number: number }>, range: { type: RangeType, distance?: { type: DistanceType, amount?: number | undefined } | undefined }, duration: Array<{ type: DurationType, units?: DurationUnit | undefined, concentration?: boolean | undefined, upTo?: boolean | undefined, amount?: number | undefined, ends?: Array<string> | undefined }>, source?: Array<{ book: string, page?: number | undefined }> | undefined, classes?: Array<{ id: string, title: string }> | undefined, feats?: Array<{ id: string, title: string }> | undefined, features?: Array<{ id: string, title: string, subClassId?: string | undefined, classId?: string | undefined, type?: FeatureType | undefined, subClass?: { classId: string } | undefined }> | undefined, subClasses?: Array<{ id: string, title: string, classId: string }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type FindClassesQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type FindClassesQuery = { findClasses: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, description: string, multiClassing: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, equipment: string, subClassDescription: string, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, trainingTable?: Array<Array<string | undefined> | undefined> | undefined, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, cases: { genitive: string }, source?: Array<{ book: string, page?: number | undefined }> | undefined, features?: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, subClasses?: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, shortDescription?: string | undefined, classId: string, order?: number | undefined, props?: any | undefined, caption: string, source?: Array<{ book: string, page?: number | undefined }> | undefined, features: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }>, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined }> | undefined, spells?: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, level: number, school: SpellSchool, damage?: Array<DamageType> | undefined, ritual?: boolean | undefined, attackType?: AttackType | undefined, basicRules?: boolean | undefined, components: { v?: boolean | undefined, s?: boolean | undefined, m?: { text?: string | undefined, consume?: any | undefined, coast?: number | undefined } | undefined }, time: Array<{ condition?: string | undefined, unit: CastingTimeUnit, number: number }>, range: { type: RangeType, distance?: { type: DistanceType, amount?: number | undefined } | undefined }, duration: Array<{ type: DurationType, units?: DurationUnit | undefined, concentration?: boolean | undefined, upTo?: boolean | undefined, amount?: number | undefined, ends?: Array<string> | undefined }>, source?: Array<{ book: string, page?: number | undefined }> | undefined, classes?: Array<{ id: string, title: string }> | undefined, feats?: Array<{ id: string, title: string }> | undefined, features?: Array<{ id: string, title: string, subClassId?: string | undefined, classId?: string | undefined, type?: FeatureType | undefined, subClass?: { classId: string } | undefined }> | undefined, subClasses?: Array<{ id: string, title: string, classId: string }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined }> };

export type SpellsClassQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SpellsClassQuery = { class: { id: string, updatedAt: string, title: string, originalTitle: string, description: string, multiClassing: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, equipment: string, subClassDescription: string, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, trainingTable?: Array<Array<string | undefined> | undefined> | undefined, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, choose?: any | undefined, spells?: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, level: number, school: SpellSchool, damage?: Array<DamageType> | undefined, ritual?: boolean | undefined, attackType?: AttackType | undefined, basicRules?: boolean | undefined, components: { v?: boolean | undefined, s?: boolean | undefined, m?: { text?: string | undefined, consume?: any | undefined, coast?: number | undefined } | undefined }, time: Array<{ condition?: string | undefined, unit: CastingTimeUnit, number: number }>, range: { type: RangeType, distance?: { type: DistanceType, amount?: number | undefined } | undefined }, duration: Array<{ type: DurationType, units?: DurationUnit | undefined, concentration?: boolean | undefined, upTo?: boolean | undefined, amount?: number | undefined, ends?: Array<string> | undefined }>, source?: Array<{ book: string, page?: number | undefined }> | undefined, classes?: Array<{ id: string, title: string }> | undefined, feats?: Array<{ id: string, title: string }> | undefined, features?: Array<{ id: string, title: string, subClassId?: string | undefined, classId?: string | undefined, type?: FeatureType | undefined, subClass?: { classId: string } | undefined }> | undefined, subClasses?: Array<{ id: string, title: string, classId: string }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined }> | undefined, cases: { genitive: string }, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type SubClassesClassQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SubClassesClassQuery = { class: { id: string, updatedAt: string, title: string, originalTitle: string, description: string, multiClassing: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, equipment: string, subClassDescription: string, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, trainingTable?: Array<Array<string | undefined> | undefined> | undefined, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, choose?: any | undefined, subClasses?: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, shortDescription?: string | undefined, classId: string, order?: number | undefined, props?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, cases: { genitive: string }, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type UpdateClassMutationVariables = Exact<{
  id: Scalars['String']['input'];
  class: ClassInput;
}>;


export type UpdateClassMutation = { updateClass: { id: string, updatedAt: string, title: string, originalTitle: string, description: string, multiClassing: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, equipment: string, subClassDescription: string, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, trainingTable?: Array<Array<string | undefined> | undefined> | undefined, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, choose?: any | undefined, cases: { genitive: string }, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type AdminCommentsQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
}>;


export type AdminCommentsQuery = { adminComments: { total: number, items: Array<{ id: string, targetType: CommentTargetType, targetId: string, targetTitle?: string | undefined, targetParentId?: string | undefined, parentId?: string | undefined, authorId: string, authorName: string, authorBlocked: boolean, text: string, isDeleted: boolean, editedBy?: string | undefined, editedAt?: string | undefined, createdAt: string }> } };

export type BlockedCommentAuthorsQueryVariables = Exact<{
  targetType: CommentTargetType;
  targetId: Scalars['String']['input'];
}>;


export type BlockedCommentAuthorsQuery = { blockedCommentAuthors: Array<string> };

export type CommentFieldsFragment = { id: string, targetType: CommentTargetType, targetId: string, parentId?: string | undefined, authorId: string, authorName: string, text: string, isDeleted: boolean, editedBy?: string | undefined, editedAt?: string | undefined, createdAt: string };

export type CommentsQueryVariables = Exact<{
  targetType: CommentTargetType;
  targetId: Scalars['String']['input'];
}>;


export type CommentsQuery = { comments: Array<{ id: string, targetType: CommentTargetType, targetId: string, parentId?: string | undefined, authorId: string, authorName: string, text: string, isDeleted: boolean, editedBy?: string | undefined, editedAt?: string | undefined, createdAt: string }> };

export type CreateCommentMutationVariables = Exact<{
  targetType: CommentTargetType;
  targetId: Scalars['String']['input'];
  text: Scalars['String']['input'];
  parentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateCommentMutation = { createComment: { id: string, targetType: CommentTargetType, targetId: string, parentId?: string | undefined, authorId: string, authorName: string, text: string, isDeleted: boolean, editedBy?: string | undefined, editedAt?: string | undefined, createdAt: string } };

export type DeleteCommentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteCommentMutation = { deleteComment: boolean };

export type SetCommentsBlockedMutationVariables = Exact<{
  userId: Scalars['String']['input'];
  blocked: Scalars['Boolean']['input'];
}>;


export type SetCommentsBlockedMutation = { setCommentsBlocked: boolean };

export type UpdateCommentMutationVariables = Exact<{
  id: Scalars['String']['input'];
  text: Scalars['String']['input'];
}>;


export type UpdateCommentMutation = { updateComment: { id: string, targetType: CommentTargetType, targetId: string, parentId?: string | undefined, authorId: string, authorName: string, text: string, isDeleted: boolean, editedBy?: string | undefined, editedAt?: string | undefined, createdAt: string } };

export type FeatQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FeatQuery = { feat: { id: string, updatedAt: string, title: string, originalTitle: string, description?: string | undefined, prerequisite?: string | undefined, category: FeatCategory, variantKey?: string | undefined, repeatable?: boolean | undefined, alternativeTitles?: Array<string> | undefined, features?: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type FeatFragment = { id: string, updatedAt: string, title: string, originalTitle: string, description?: string | undefined, prerequisite?: string | undefined, category: FeatCategory, variantKey?: string | undefined, repeatable?: boolean | undefined, alternativeTitles?: Array<string> | undefined, features?: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined };

export type FeatsQueryVariables = Exact<{
  filters?: InputMaybe<FeatFilterInput>;
}>;


export type FeatsQuery = { feats: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, category: FeatCategory }> };

export type FindFeatQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type FindFeatQuery = { findFeat: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, description?: string | undefined, prerequisite?: string | undefined, category: FeatCategory, variantKey?: string | undefined, repeatable?: boolean | undefined, alternativeTitles?: Array<string> | undefined, features?: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined }> };

export type UpdateFeatMutationVariables = Exact<{
  id: Scalars['String']['input'];
  feat: FeatInput;
}>;


export type UpdateFeatMutation = { updateFeat: { id: string, updatedAt: string, title: string, originalTitle: string, description?: string | undefined, prerequisite?: string | undefined, category: FeatCategory, variantKey?: string | undefined, repeatable?: boolean | undefined, alternativeTitles?: Array<string> | undefined, features?: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type FeatureQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FeatureQuery = { feature: { id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined } };

export type FeatureFragment = { id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined };

export type FeaturesByTypeQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type FeaturesByTypeQuery = { featuresByType: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> };

export type FeaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type FeaturesQuery = { features: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> };

export type FindFeaturesQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type FindFeaturesQuery = { findFeatures: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, class?: { id: string, updatedAt: string, title: string, originalTitle: string, description: string, multiClassing: string, shortDescription: string, hitDie: number, primaryAbility: Array<Ability>, saves: Array<Ability>, equipment: string, subClassDescription: string, columns: Array<string>, rows?: Array<Array<string | undefined> | undefined> | undefined, trainingTable?: Array<Array<string | undefined> | undefined> | undefined, hasSpells: boolean, sections?: any | undefined, props?: any | undefined, choose?: any | undefined, cases: { genitive: string }, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } | undefined }> };

export type UpdateFeatureMutationVariables = Exact<{
  id: Scalars['String']['input'];
  feature: FeatureInput;
}>;


export type UpdateFeatureMutation = { updateFeature: { id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined } };

export type FindGlossaryItemsQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type FindGlossaryItemsQuery = { findGlossaryItems: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, type?: GlossaryType | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> };

export type GlossaryItemQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GlossaryItemQuery = { glossaryItem: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, type?: GlossaryType | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined } };

export type GlossaryItemFragment = { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, type?: GlossaryType | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined };

export type GlossaryItemsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlossaryItemsQuery = { glossaryItems: Array<{ id: string, title: string, type?: GlossaryType | undefined }> };

export type UpdateGlossaryItemMutationVariables = Exact<{
  id: Scalars['String']['input'];
  glossaryItem: GlossaryItemInput;
}>;


export type UpdateGlossaryItemMutation = { updateGlossaryItem: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, type?: GlossaryType | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined } };

export type DayCardQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type DayCardQuery = { dayCard?: { kind: string, id: string, title: string, originalTitle?: string | undefined, subtitle?: string | undefined, text?: string | undefined, imagePath?: string | undefined } | undefined };

export type AddEntityImageMutationVariables = Exact<{
  target: ImageTarget;
  targetId: Scalars['String']['input'];
  path: Scalars['String']['input'];
  width: Scalars['Int']['input'];
  height: Scalars['Int']['input'];
  credits?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddEntityImageMutation = { addEntityImage: { id: string, path: string } };

export type DeleteEntityImageMutationVariables = Exact<{
  target: ImageTarget;
  targetId: Scalars['String']['input'];
  imageId: Scalars['String']['input'];
}>;


export type DeleteEntityImageMutation = { deleteEntityImage?: string | undefined };

export type ImageFragment = { id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string };

export type ReorderEntityImagesMutationVariables = Exact<{
  target: ImageTarget;
  targetId: Scalars['String']['input'];
  imageIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ReorderEntityImagesMutation = { reorderEntityImages: boolean };

export type UpdateImageMutationVariables = Exact<{
  id: Scalars['String']['input'];
  credits?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  originDescription?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateImageMutation = { updateImage: { id: string, credits?: string | undefined, description?: string | undefined, originDescription?: string | undefined } };

export type FindItemsQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type FindItemsQuery = { findItems: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, tier?: ItemTier | undefined, rarity: ItemRarity, wondrous?: boolean | undefined, reqAttune?: boolean | undefined, reqAttuneText?: string | undefined, reqAttuneTags?: any | undefined, weight?: number | undefined, basicRules?: boolean | undefined, price?: number | undefined, strength?: number | undefined, stealth?: boolean | undefined, poisonType?: PoisonType | undefined, weaponCategory?: WeaponCategory | undefined, weaponProperty?: Array<WeaponProperty> | undefined, age?: AgeType | undefined, range?: string | undefined, dmg1?: string | undefined, dmg2?: string | undefined, dmgType?: DamageType | undefined, bonusWeapon?: string | undefined, bonusWeaponDamage?: string | undefined, ac?: number | undefined, bonusAc?: number | undefined, speed?: number | undefined, carryingCapacity?: number | undefined, vehDmgThresh?: number | undefined, capCargo?: number | undefined, capPassenger?: number | undefined, vehSpeed?: number | undefined, vehHp?: number | undefined, vehAc?: number | undefined, crew?: number | undefined, reloadCount?: number | undefined, light?: any | undefined, weaponMasteryNote?: string | undefined, weaponMastery?: Array<WeaponMastery> | undefined, valueRarity?: ItemRarity | undefined, dimensions?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, globalDescriptions?: Array<{ id: string, title: string, description: string, headingLevel?: string | undefined }> | undefined }> };

export type ItemQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ItemQuery = { item: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, tier?: ItemTier | undefined, rarity: ItemRarity, wondrous?: boolean | undefined, reqAttune?: boolean | undefined, reqAttuneText?: string | undefined, reqAttuneTags?: any | undefined, weight?: number | undefined, basicRules?: boolean | undefined, price?: number | undefined, strength?: number | undefined, stealth?: boolean | undefined, poisonType?: PoisonType | undefined, weaponCategory?: WeaponCategory | undefined, weaponProperty?: Array<WeaponProperty> | undefined, age?: AgeType | undefined, range?: string | undefined, dmg1?: string | undefined, dmg2?: string | undefined, dmgType?: DamageType | undefined, bonusWeapon?: string | undefined, bonusWeaponDamage?: string | undefined, ac?: number | undefined, bonusAc?: number | undefined, speed?: number | undefined, carryingCapacity?: number | undefined, vehDmgThresh?: number | undefined, capCargo?: number | undefined, capPassenger?: number | undefined, vehSpeed?: number | undefined, vehHp?: number | undefined, vehAc?: number | undefined, crew?: number | undefined, reloadCount?: number | undefined, light?: any | undefined, weaponMasteryNote?: string | undefined, weaponMastery?: Array<WeaponMastery> | undefined, valueRarity?: ItemRarity | undefined, dimensions?: any | undefined, parentItem?: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, tier?: ItemTier | undefined, rarity: ItemRarity, wondrous?: boolean | undefined, reqAttune?: boolean | undefined, reqAttuneText?: string | undefined, reqAttuneTags?: any | undefined, weight?: number | undefined, basicRules?: boolean | undefined, price?: number | undefined, strength?: number | undefined, stealth?: boolean | undefined, poisonType?: PoisonType | undefined, weaponCategory?: WeaponCategory | undefined, weaponProperty?: Array<WeaponProperty> | undefined, age?: AgeType | undefined, range?: string | undefined, dmg1?: string | undefined, dmg2?: string | undefined, dmgType?: DamageType | undefined, bonusWeapon?: string | undefined, bonusWeaponDamage?: string | undefined, ac?: number | undefined, bonusAc?: number | undefined, speed?: number | undefined, carryingCapacity?: number | undefined, vehDmgThresh?: number | undefined, capCargo?: number | undefined, capPassenger?: number | undefined, vehSpeed?: number | undefined, vehHp?: number | undefined, vehAc?: number | undefined, crew?: number | undefined, reloadCount?: number | undefined, light?: any | undefined, weaponMasteryNote?: string | undefined, weaponMastery?: Array<WeaponMastery> | undefined, valueRarity?: ItemRarity | undefined, dimensions?: any | undefined, baseItem?: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, tier?: ItemTier | undefined, rarity: ItemRarity, wondrous?: boolean | undefined, reqAttune?: boolean | undefined, reqAttuneText?: string | undefined, reqAttuneTags?: any | undefined, weight?: number | undefined, basicRules?: boolean | undefined, price?: number | undefined, strength?: number | undefined, stealth?: boolean | undefined, poisonType?: PoisonType | undefined, weaponCategory?: WeaponCategory | undefined, weaponProperty?: Array<WeaponProperty> | undefined, age?: AgeType | undefined, range?: string | undefined, dmg1?: string | undefined, dmg2?: string | undefined, dmgType?: DamageType | undefined, bonusWeapon?: string | undefined, bonusWeaponDamage?: string | undefined, ac?: number | undefined, bonusAc?: number | undefined, speed?: number | undefined, carryingCapacity?: number | undefined, vehDmgThresh?: number | undefined, capCargo?: number | undefined, capPassenger?: number | undefined, vehSpeed?: number | undefined, vehHp?: number | undefined, vehAc?: number | undefined, crew?: number | undefined, reloadCount?: number | undefined, light?: any | undefined, weaponMasteryNote?: string | undefined, weaponMastery?: Array<WeaponMastery> | undefined, valueRarity?: ItemRarity | undefined, dimensions?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, globalDescriptions?: Array<{ id: string, title: string, description: string, headingLevel?: string | undefined }> | undefined } | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, globalDescriptions?: Array<{ id: string, title: string, description: string, headingLevel?: string | undefined }> | undefined } | undefined, baseItem?: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, tier?: ItemTier | undefined, rarity: ItemRarity, wondrous?: boolean | undefined, reqAttune?: boolean | undefined, reqAttuneText?: string | undefined, reqAttuneTags?: any | undefined, weight?: number | undefined, basicRules?: boolean | undefined, price?: number | undefined, strength?: number | undefined, stealth?: boolean | undefined, poisonType?: PoisonType | undefined, weaponCategory?: WeaponCategory | undefined, weaponProperty?: Array<WeaponProperty> | undefined, age?: AgeType | undefined, range?: string | undefined, dmg1?: string | undefined, dmg2?: string | undefined, dmgType?: DamageType | undefined, bonusWeapon?: string | undefined, bonusWeaponDamage?: string | undefined, ac?: number | undefined, bonusAc?: number | undefined, speed?: number | undefined, carryingCapacity?: number | undefined, vehDmgThresh?: number | undefined, capCargo?: number | undefined, capPassenger?: number | undefined, vehSpeed?: number | undefined, vehHp?: number | undefined, vehAc?: number | undefined, crew?: number | undefined, reloadCount?: number | undefined, light?: any | undefined, weaponMasteryNote?: string | undefined, weaponMastery?: Array<WeaponMastery> | undefined, valueRarity?: ItemRarity | undefined, dimensions?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, globalDescriptions?: Array<{ id: string, title: string, description: string, headingLevel?: string | undefined }> | undefined } | undefined, ammoItem?: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, tier?: ItemTier | undefined, rarity: ItemRarity, wondrous?: boolean | undefined, reqAttune?: boolean | undefined, reqAttuneText?: string | undefined, reqAttuneTags?: any | undefined, weight?: number | undefined, basicRules?: boolean | undefined, price?: number | undefined, strength?: number | undefined, stealth?: boolean | undefined, poisonType?: PoisonType | undefined, weaponCategory?: WeaponCategory | undefined, weaponProperty?: Array<WeaponProperty> | undefined, age?: AgeType | undefined, range?: string | undefined, dmg1?: string | undefined, dmg2?: string | undefined, dmgType?: DamageType | undefined, bonusWeapon?: string | undefined, bonusWeaponDamage?: string | undefined, ac?: number | undefined, bonusAc?: number | undefined, speed?: number | undefined, carryingCapacity?: number | undefined, vehDmgThresh?: number | undefined, capCargo?: number | undefined, capPassenger?: number | undefined, vehSpeed?: number | undefined, vehHp?: number | undefined, vehAc?: number | undefined, crew?: number | undefined, reloadCount?: number | undefined, light?: any | undefined, weaponMasteryNote?: string | undefined, weaponMastery?: Array<WeaponMastery> | undefined, valueRarity?: ItemRarity | undefined, dimensions?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, globalDescriptions?: Array<{ id: string, title: string, description: string, headingLevel?: string | undefined }> | undefined } | undefined, requires?: { types?: Array<ItemTypeDetail> | undefined, weaponCategories?: Array<WeaponCategory> | undefined, items?: Array<{ id: string, title: string }> | undefined } | undefined, excludes?: { types?: Array<ItemTypeDetail> | undefined, weaponCategories?: Array<WeaponCategory> | undefined, items?: Array<{ id: string, title: string }> | undefined } | undefined, mountMonster?: { id: string } | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined, legacyItem?: { id: string, title: string } | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, globalDescriptions?: Array<{ id: string, title: string, description: string, headingLevel?: string | undefined }> | undefined } };

export type ItemFragment = { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, tier?: ItemTier | undefined, rarity: ItemRarity, wondrous?: boolean | undefined, reqAttune?: boolean | undefined, reqAttuneText?: string | undefined, reqAttuneTags?: any | undefined, weight?: number | undefined, basicRules?: boolean | undefined, price?: number | undefined, strength?: number | undefined, stealth?: boolean | undefined, poisonType?: PoisonType | undefined, weaponCategory?: WeaponCategory | undefined, weaponProperty?: Array<WeaponProperty> | undefined, age?: AgeType | undefined, range?: string | undefined, dmg1?: string | undefined, dmg2?: string | undefined, dmgType?: DamageType | undefined, bonusWeapon?: string | undefined, bonusWeaponDamage?: string | undefined, ac?: number | undefined, bonusAc?: number | undefined, speed?: number | undefined, carryingCapacity?: number | undefined, vehDmgThresh?: number | undefined, capCargo?: number | undefined, capPassenger?: number | undefined, vehSpeed?: number | undefined, vehHp?: number | undefined, vehAc?: number | undefined, crew?: number | undefined, reloadCount?: number | undefined, light?: any | undefined, weaponMasteryNote?: string | undefined, weaponMastery?: Array<WeaponMastery> | undefined, valueRarity?: ItemRarity | undefined, dimensions?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, globalDescriptions?: Array<{ id: string, title: string, description: string, headingLevel?: string | undefined }> | undefined };

export type ItemsQueryVariables = Exact<{
  types?: InputMaybe<Array<ItemType> | ItemType>;
  withoutBaseItem?: InputMaybe<Scalars['Boolean']['input']>;
  filters?: InputMaybe<ItemFilterInput>;
}>;


export type ItemsQuery = { items: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, rarity: ItemRarity, wondrous?: boolean | undefined, weaponProperty?: Array<WeaponProperty> | undefined, weaponCategory?: WeaponCategory | undefined, weaponMastery?: Array<WeaponMastery> | undefined }> };

export type UpdateItemMutationVariables = Exact<{
  id: Scalars['String']['input'];
  item: ItemInput;
}>;


export type UpdateItemMutation = { updateItem: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, type?: ItemType | undefined, subType?: Array<ItemSubType> | undefined, tier?: ItemTier | undefined, rarity: ItemRarity, wondrous?: boolean | undefined, reqAttune?: boolean | undefined, reqAttuneText?: string | undefined, reqAttuneTags?: any | undefined, weight?: number | undefined, basicRules?: boolean | undefined, price?: number | undefined, strength?: number | undefined, stealth?: boolean | undefined, poisonType?: PoisonType | undefined, weaponCategory?: WeaponCategory | undefined, weaponProperty?: Array<WeaponProperty> | undefined, age?: AgeType | undefined, range?: string | undefined, dmg1?: string | undefined, dmg2?: string | undefined, dmgType?: DamageType | undefined, bonusWeapon?: string | undefined, bonusWeaponDamage?: string | undefined, ac?: number | undefined, bonusAc?: number | undefined, speed?: number | undefined, carryingCapacity?: number | undefined, vehDmgThresh?: number | undefined, capCargo?: number | undefined, capPassenger?: number | undefined, vehSpeed?: number | undefined, vehHp?: number | undefined, vehAc?: number | undefined, crew?: number | undefined, reloadCount?: number | undefined, light?: any | undefined, weaponMasteryNote?: string | undefined, weaponMastery?: Array<WeaponMastery> | undefined, valueRarity?: ItemRarity | undefined, dimensions?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, globalDescriptions?: Array<{ id: string, title: string, description: string, headingLevel?: string | undefined }> | undefined } };

export type LanguagesQueryVariables = Exact<{
  standard?: InputMaybe<Scalars['Boolean']['input']>;
  exotic?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
}>;


export type LanguagesQuery = { languages: Array<{ id: string, title: string }> };

export type CreateMapLabelMutationVariables = Exact<{
  mapId: Scalars['String']['input'];
  label: MapLabelCreateInput;
}>;


export type CreateMapLabelMutation = { createMapLabel: { id: number, title: string, originalTitle: string, kind: string, marker?: string | undefined, x: number, y: number, align: string, layer: string, lines: number, angle: number, size: number, markerX?: number | undefined, markerY?: number | undefined, polygon?: Array<Array<number>> | undefined, wikiArticleId?: string | undefined } };

export type DeleteMapLabelMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type DeleteMapLabelMutation = { deleteMapLabel: boolean };

export type GameMapDataQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GameMapDataQuery = { gameMap?: { id: string, labels: Array<{ id: number, title: string, originalTitle: string, kind: string, marker?: string | undefined, x: number, y: number, align: string, layer: string, lines: number, angle: number, size: number, markerX?: number | undefined, markerY?: number | undefined, polygon?: Array<Array<number>> | undefined, wikiArticleId?: string | undefined }>, paths: Array<{ id: number, kind: string, points: Array<number> }> } | undefined };

export type MapLabelFragment = { id: number, title: string, originalTitle: string, kind: string, marker?: string | undefined, x: number, y: number, align: string, layer: string, lines: number, angle: number, size: number, markerX?: number | undefined, markerY?: number | undefined, polygon?: Array<Array<number>> | undefined, wikiArticleId?: string | undefined };

export type GameMapQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type GameMapQuery = { gameMap?: { id: string, updatedAt: string, title: string, originalTitle: string, description?: string | undefined, width: number, height: number, tilePath: string, tileSize: number, maxZoom: number, milesPerPixel?: number | undefined } | undefined };

export type GameMapsQueryVariables = Exact<{ [key: string]: never; }>;


export type GameMapsQuery = { gameMaps: Array<{ id: string, title: string, originalTitle: string, description?: string | undefined, preview?: string | undefined }> };

export type UpdateMapGeometryMutationVariables = Exact<{
  mapId: Scalars['String']['input'];
  labels?: InputMaybe<Array<MapLabelGeometryInput> | MapLabelGeometryInput>;
  paths?: InputMaybe<Array<MapPathGeometryInput> | MapPathGeometryInput>;
}>;


export type UpdateMapGeometryMutation = { updateMapGeometry: boolean };

export type UpdateMapLabelMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  label: MapLabelInput;
}>;


export type UpdateMapLabelMutation = { updateMapLabel: { id: number, title: string, originalTitle: string, kind: string, marker?: string | undefined, x: number, y: number, align: string, layer: string, lines: number, angle: number, size: number, markerX?: number | undefined, markerY?: number | undefined, polygon?: Array<Array<number>> | undefined, wikiArticleId?: string | undefined } };

export type MonsterTraitQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MonsterTraitQuery = { monsterTrait: { id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined } };

export type UpdateMonsterTraitMutationVariables = Exact<{
  id: Scalars['String']['input'];
  trait: MonsterTraitInput;
}>;


export type UpdateMonsterTraitMutation = { updateMonsterTrait: { id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined } };

export type FindMonstersQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type FindMonstersQuery = { findMonsters: Array<{ id: string, title: string }> };

export type MonsterQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MonsterQuery = { monster: { id: string, updatedAt: string, originalTitle: string, title: string, alternativeTitles?: Array<string> | undefined, shortTitle?: string | undefined, description?: string | undefined, size?: Array<Size> | undefined, types: Array<string>, subType?: Array<string> | undefined, swarmSize?: Size | undefined, alignment?: Array<string> | undefined, ac?: number | undefined, acNote?: string | undefined, hp: string, speed?: any | undefined, str: number, dex: number, con: number, int: number, wis: number, cha: number, skills?: any | undefined, saves?: any | undefined, immune?: Array<any> | undefined, conditionImmune?: Array<any> | undefined, resist?: Array<any> | undefined, vulnerable?: Array<any> | undefined, senses?: Array<any> | undefined, passive: number, languages?: any | undefined, understandLanguages?: any | undefined, telepathy?: any | undefined, gear?: Array<any> | undefined, cr?: string | undefined, xpLair?: number | undefined, initiativeProfBonus?: number | undefined, proficiencyNote?: string | undefined, legendaryActionsLairCount?: number | undefined, legendaryActionsCount?: number | undefined, groupTmp?: string | undefined, legacyMonsters?: Array<{ id: string, title: string, size?: Array<Size> | undefined, types: Array<string>, subType?: Array<string> | undefined, swarmSize?: Size | undefined, alignment?: Array<string> | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, features?: Array<{ id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined }> | undefined, actions?: Array<{ id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined }> | undefined, reactions?: Array<{ id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined }> | undefined, legendaryActions?: Array<{ id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined }> | undefined, bonusActions?: Array<{ id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined }> | undefined, lairTraits?: Array<{ id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined }> | undefined, group?: { id: string, title: string, originalTitle: string, description?: string | undefined, originalDescription?: string | undefined, originalAbout?: string | undefined, environment?: Array<string> | undefined, treasure?: Array<string> | undefined, about?: string | undefined } | undefined, mount?: { id: string } | undefined, monsterLair?: { id: string, title: string, description?: string | undefined } | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined, token?: { id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string } | undefined, globalDescriptions: Array<{ id: string, title: string, description: string }>, legacyDescriptions?: Array<{ id: string, title: string, description?: string | undefined }> | undefined } };

export type MonsterTraitFragment = { id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined };

export type MonsterFragment = { id: string, updatedAt: string, originalTitle: string, title: string, alternativeTitles?: Array<string> | undefined, shortTitle?: string | undefined, description?: string | undefined, size?: Array<Size> | undefined, types: Array<string>, subType?: Array<string> | undefined, swarmSize?: Size | undefined, alignment?: Array<string> | undefined, ac?: number | undefined, acNote?: string | undefined, hp: string, speed?: any | undefined, str: number, dex: number, con: number, int: number, wis: number, cha: number, skills?: any | undefined, saves?: any | undefined, immune?: Array<any> | undefined, conditionImmune?: Array<any> | undefined, resist?: Array<any> | undefined, vulnerable?: Array<any> | undefined, senses?: Array<any> | undefined, passive: number, languages?: any | undefined, understandLanguages?: any | undefined, telepathy?: any | undefined, gear?: Array<any> | undefined, cr?: string | undefined, xpLair?: number | undefined, initiativeProfBonus?: number | undefined, proficiencyNote?: string | undefined, legendaryActionsLairCount?: number | undefined, legendaryActionsCount?: number | undefined, groupTmp?: string | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, features?: Array<{ id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined }> | undefined, actions?: Array<{ id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined }> | undefined, reactions?: Array<{ id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined }> | undefined, legendaryActions?: Array<{ id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined }> | undefined, bonusActions?: Array<{ id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined }> | undefined, lairTraits?: Array<{ id: string, originalTitle?: string | undefined, title: string, description: string, type: TraitType, actionType?: ActionType | undefined, availSpells?: Array<{ slots: string, isEach: boolean, spells: Array<{ id: string, title: string, originalComment?: string | undefined, comment?: string | undefined }> }> | undefined }> | undefined, group?: { id: string, title: string, originalTitle: string, description?: string | undefined, originalDescription?: string | undefined, originalAbout?: string | undefined, environment?: Array<string> | undefined, treasure?: Array<string> | undefined, about?: string | undefined } | undefined, mount?: { id: string } | undefined, monsterLair?: { id: string, title: string, description?: string | undefined } | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined, token?: { id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string } | undefined, globalDescriptions: Array<{ id: string, title: string, description: string }>, legacyDescriptions?: Array<{ id: string, title: string, description?: string | undefined }> | undefined };

export type MonsterGroupFragment = { id: string, title: string, originalTitle: string, description?: string | undefined, originalDescription?: string | undefined, originalAbout?: string | undefined, environment?: Array<string> | undefined, treasure?: Array<string> | undefined, about?: string | undefined };

export type FlatMonsterFragment = { id: string, originalTitle: string, title: string, alternativeTitles?: Array<string> | undefined, shortTitle?: string | undefined, description?: string | undefined, size?: Array<Size> | undefined, types: Array<string>, subType?: Array<string> | undefined, swarmSize?: Size | undefined, alignment?: Array<string> | undefined, ac?: number | undefined, acNote?: string | undefined, hp: string, speed?: any | undefined, str: number, dex: number, con: number, int: number, wis: number, cha: number, skills?: any | undefined, saves?: any | undefined, immune?: Array<any> | undefined, conditionImmune?: Array<any> | undefined, resist?: Array<any> | undefined, vulnerable?: Array<any> | undefined, senses?: Array<any> | undefined, passive: number, languages?: any | undefined, understandLanguages?: any | undefined, telepathy?: any | undefined, gear?: Array<any> | undefined, cr?: string | undefined, xpLair?: number | undefined, initiativeProfBonus?: number | undefined, proficiencyNote?: string | undefined, legendaryActionsLairCount?: number | undefined, legendaryActionsCount?: number | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined };

export type MonstersQueryVariables = Exact<{
  filters?: InputMaybe<MonsterFilterInput>;
}>;


export type MonstersQuery = { monsters: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, legacyTitles?: Array<string> | undefined, cr?: string | undefined, size?: Array<Size> | undefined, types: Array<string>, subType?: Array<string> | undefined, swarmSize?: Size | undefined, alignment?: Array<string> | undefined }> };

export type UpdateMonsterDescriptionMutationVariables = Exact<{
  id: Scalars['String']['input'];
  monster: MonsterDescriptionInput;
}>;


export type UpdateMonsterDescriptionMutation = { updateMonsterDescription?: { id: string, description?: string | undefined } | undefined };

export type UpdateMonsterGroupMutationVariables = Exact<{
  id: Scalars['String']['input'];
  group: MonsterGroupInput;
}>;


export type UpdateMonsterGroupMutation = { updateMonsterGroup?: { id: string, title: string, originalTitle: string, about?: string | undefined, originalAbout?: string | undefined, description?: string | undefined, originalDescription?: string | undefined, environment?: Array<string> | undefined, treasure?: Array<string> | undefined } | undefined };

export type UpdateMonsterMutationVariables = Exact<{
  id: Scalars['String']['input'];
  monster: MonsterInput;
}>;


export type UpdateMonsterMutation = { updateMonster: { id: string, originalTitle: string, title: string, alternativeTitles?: Array<string> | undefined, shortTitle?: string | undefined, description?: string | undefined, size?: Array<Size> | undefined, types: Array<string>, subType?: Array<string> | undefined, swarmSize?: Size | undefined, alignment?: Array<string> | undefined, ac?: number | undefined, acNote?: string | undefined, hp: string, speed?: any | undefined, str: number, dex: number, con: number, int: number, wis: number, cha: number, skills?: any | undefined, saves?: any | undefined, immune?: Array<any> | undefined, conditionImmune?: Array<any> | undefined, resist?: Array<any> | undefined, vulnerable?: Array<any> | undefined, senses?: Array<any> | undefined, passive: number, languages?: any | undefined, understandLanguages?: any | undefined, telepathy?: any | undefined, gear?: Array<any> | undefined, cr?: string | undefined, xpLair?: number | undefined, initiativeProfBonus?: number | undefined, proficiencyNote?: string | undefined, legendaryActionsLairCount?: number | undefined, legendaryActionsCount?: number | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined } };

export type NameSetsQueryVariables = Exact<{ [key: string]: never; }>;


export type NameSetsQuery = { nameSets: Array<{ id: string, title: string, genitive: string, specieId?: string | undefined, updatedAt: string, groups: Array<{ code: string, title: string, role: string, people?: string | undefined, familyFirst?: boolean | undefined, noteLabel?: string | undefined, items: Array<string> }> }> };

export type OriginQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type OriginQuery = { origin: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, abilities: string, feat: string, skills: string, instruments: string, equipment: string, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type OriginFragment = { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, abilities: string, feat: string, skills: string, instruments: string, equipment: string, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined };

export type OriginsQueryVariables = Exact<{
  filters?: InputMaybe<OriginFilterInput>;
}>;


export type OriginsQuery = { origins: Array<{ id: string, title: string, originalTitle: string, abilities: string, feat: string, featId?: string | undefined, featVariant?: string | undefined, featCategory?: string | undefined, skills: string, instruments: string }> };

export type UpdateOriginMutationVariables = Exact<{
  id: Scalars['String']['input'];
  origin: OriginInput;
}>;


export type UpdateOriginMutation = { updateOrigin: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, abilities: string, feat: string, skills: string, instruments: string, equipment: string, source?: Array<{ book: string, page?: number | undefined }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type SearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  section?: InputMaybe<SearchSection>;
  prefer?: InputMaybe<SearchSection>;
}>;


export type SearchQuery = { searchResult: { correctedQuery?: string | undefined, groups: Array<{ section: SearchSection, total: number, hits: Array<{ entity: SearchEntity, id: string, title: string, alternativeTitle?: string | undefined, subtitle?: string | undefined, snippet?: string | undefined, highlights: Array<string>, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, bookId?: string | undefined, chapterId?: string | undefined, featureType?: FeatureType | undefined, href?: string | undefined }> }> } };

export type AboutSpecieQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type AboutSpecieQuery = { specie: { id: string, updatedAt: string, title: string, originalTitle: string, description?: string | undefined, featuresDescription?: string | undefined, type: string, speed: number, props?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, sizes: Array<{ category: Size, tallFrom: number, tallTo: number }>, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type SpecieQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SpecieQuery = { specie: { id: string, updatedAt: string, title: string, originalTitle: string, description?: string | undefined, featuresDescription?: string | undefined, type: string, speed: number, props?: any | undefined, features?: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, sizes: Array<{ category: Size, tallFrom: number, tallTo: number }>, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type SpecieFragment = { id: string, updatedAt: string, title: string, originalTitle: string, description?: string | undefined, type: string, featuresDescription?: string | undefined, speed: number, props?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, features?: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }> | undefined, sizes: Array<{ category: Size, tallFrom: number, tallTo: number }>, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined };

export type FlatSpecieFragment = { id: string, updatedAt: string, title: string, originalTitle: string, description?: string | undefined, featuresDescription?: string | undefined, type: string, speed: number, props?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, sizes: Array<{ category: Size, tallFrom: number, tallTo: number }>, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined };

export type SpeciesQueryVariables = Exact<{ [key: string]: never; }>;


export type SpeciesQuery = { species: Array<{ id: string, title: string, speed: number, props?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, sizes: Array<{ category: Size }> }> };

export type UpdateSpecieMutationVariables = Exact<{
  id: Scalars['String']['input'];
  specie: SpecieInput;
}>;


export type UpdateSpecieMutation = { updateSpecie: { id: string, updatedAt: string, title: string, originalTitle: string, description?: string | undefined, featuresDescription?: string | undefined, type: string, speed: number, props?: any | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, sizes: Array<{ category: Size, tallFrom: number, tallTo: number }>, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type CreateSpellMutationVariables = Exact<{
  spell: SpellInput;
}>;


export type CreateSpellMutation = { createSpell: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, level: number, school: SpellSchool, damage?: Array<DamageType> | undefined, ritual?: boolean | undefined, attackType?: AttackType | undefined, basicRules?: boolean | undefined, components: { v?: boolean | undefined, s?: boolean | undefined, m?: { text?: string | undefined, consume?: any | undefined, coast?: number | undefined } | undefined }, time: Array<{ condition?: string | undefined, unit: CastingTimeUnit, number: number }>, range: { type: RangeType, distance?: { type: DistanceType, amount?: number | undefined } | undefined }, duration: Array<{ type: DurationType, units?: DurationUnit | undefined, concentration?: boolean | undefined, upTo?: boolean | undefined, amount?: number | undefined, ends?: Array<string> | undefined }>, source?: Array<{ book: string, page?: number | undefined }> | undefined, classes?: Array<{ id: string, title: string }> | undefined, feats?: Array<{ id: string, title: string }> | undefined, features?: Array<{ id: string, title: string, subClassId?: string | undefined, classId?: string | undefined, type?: FeatureType | undefined, subClass?: { classId: string } | undefined }> | undefined, subClasses?: Array<{ id: string, title: string, classId: string }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type FindSpellsQueryVariables = Exact<{
  text: Scalars['String']['input'];
}>;


export type FindSpellsQuery = { findSpells: Array<{ id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, level: number, school: SpellSchool, damage?: Array<DamageType> | undefined, ritual?: boolean | undefined, attackType?: AttackType | undefined, basicRules?: boolean | undefined, components: { v?: boolean | undefined, s?: boolean | undefined, m?: { text?: string | undefined, consume?: any | undefined, coast?: number | undefined } | undefined }, time: Array<{ condition?: string | undefined, unit: CastingTimeUnit, number: number }>, range: { type: RangeType, distance?: { type: DistanceType, amount?: number | undefined } | undefined }, duration: Array<{ type: DurationType, units?: DurationUnit | undefined, concentration?: boolean | undefined, upTo?: boolean | undefined, amount?: number | undefined, ends?: Array<string> | undefined }>, source?: Array<{ book: string, page?: number | undefined }> | undefined, classes?: Array<{ id: string, title: string }> | undefined, feats?: Array<{ id: string, title: string }> | undefined, features?: Array<{ id: string, title: string, subClassId?: string | undefined, classId?: string | undefined, type?: FeatureType | undefined, subClass?: { classId: string } | undefined }> | undefined, subClasses?: Array<{ id: string, title: string, classId: string }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined }> };

export type SpellQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SpellQuery = { spell: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, level: number, school: SpellSchool, damage?: Array<DamageType> | undefined, ritual?: boolean | undefined, attackType?: AttackType | undefined, basicRules?: boolean | undefined, legacySpell?: { id: string, title: string } | undefined, components: { v?: boolean | undefined, s?: boolean | undefined, m?: { text?: string | undefined, consume?: any | undefined, coast?: number | undefined } | undefined }, time: Array<{ condition?: string | undefined, unit: CastingTimeUnit, number: number }>, range: { type: RangeType, distance?: { type: DistanceType, amount?: number | undefined } | undefined }, duration: Array<{ type: DurationType, units?: DurationUnit | undefined, concentration?: boolean | undefined, upTo?: boolean | undefined, amount?: number | undefined, ends?: Array<string> | undefined }>, source?: Array<{ book: string, page?: number | undefined }> | undefined, classes?: Array<{ id: string, title: string }> | undefined, feats?: Array<{ id: string, title: string }> | undefined, features?: Array<{ id: string, title: string, subClassId?: string | undefined, classId?: string | undefined, type?: FeatureType | undefined, subClass?: { classId: string } | undefined }> | undefined, subClasses?: Array<{ id: string, title: string, classId: string }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type SpellFragment = { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, level: number, school: SpellSchool, damage?: Array<DamageType> | undefined, ritual?: boolean | undefined, attackType?: AttackType | undefined, basicRules?: boolean | undefined, components: { v?: boolean | undefined, s?: boolean | undefined, m?: { text?: string | undefined, consume?: any | undefined, coast?: number | undefined } | undefined }, time: Array<{ condition?: string | undefined, unit: CastingTimeUnit, number: number }>, range: { type: RangeType, distance?: { type: DistanceType, amount?: number | undefined } | undefined }, duration: Array<{ type: DurationType, units?: DurationUnit | undefined, concentration?: boolean | undefined, upTo?: boolean | undefined, amount?: number | undefined, ends?: Array<string> | undefined }>, source?: Array<{ book: string, page?: number | undefined }> | undefined, classes?: Array<{ id: string, title: string }> | undefined, feats?: Array<{ id: string, title: string }> | undefined, features?: Array<{ id: string, title: string, subClassId?: string | undefined, classId?: string | undefined, type?: FeatureType | undefined, subClass?: { classId: string } | undefined }> | undefined, subClasses?: Array<{ id: string, title: string, classId: string }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined };

export type SpellsCardsQueryVariables = Exact<{
  filters?: InputMaybe<SpellFilterInput>;
}>;


export type SpellsCardsQuery = { spells: Array<{ id: string, title: string, description?: string | undefined, cardDescription?: string | undefined, school: SpellSchool, level: number, damage?: Array<DamageType> | undefined, ritual?: boolean | undefined, attackType?: AttackType | undefined, savingThrow?: Array<Ability> | undefined, components: { v?: boolean | undefined, s?: boolean | undefined, m?: { text?: string | undefined, consume?: any | undefined, coast?: number | undefined } | undefined }, time: Array<{ condition?: string | undefined, unit: CastingTimeUnit, number: number }>, range: { type: RangeType, distance?: { type: DistanceType, amount?: number | undefined } | undefined }, duration: Array<{ type: DurationType, units?: DurationUnit | undefined, concentration?: boolean | undefined, upTo?: boolean | undefined, amount?: number | undefined, ends?: Array<string> | undefined }>, source?: Array<{ book: string, page?: number | undefined }> | undefined }> };

export type SpellsWithClassesQueryVariables = Exact<{ [key: string]: never; }>;


export type SpellsWithClassesQuery = { spellsWithClasses: Array<{ id: string, title: string, level: number, school: SpellSchool, classes?: Array<{ id: string, title: string }> | undefined }> };

export type SpellsQueryVariables = Exact<{
  filters?: InputMaybe<SpellFilterInput>;
}>;


export type SpellsQuery = { spells: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, school: SpellSchool, level: number, ritual?: boolean | undefined, duration: Array<{ concentration?: boolean | undefined }> }> };

export type UpdateSpellMutationVariables = Exact<{
  id: Scalars['String']['input'];
  spell: SpellInput;
}>;


export type UpdateSpellMutation = { updateSpell: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, level: number, school: SpellSchool, damage?: Array<DamageType> | undefined, ritual?: boolean | undefined, attackType?: AttackType | undefined, basicRules?: boolean | undefined, components: { v?: boolean | undefined, s?: boolean | undefined, m?: { text?: string | undefined, consume?: any | undefined, coast?: number | undefined } | undefined }, time: Array<{ condition?: string | undefined, unit: CastingTimeUnit, number: number }>, range: { type: RangeType, distance?: { type: DistanceType, amount?: number | undefined } | undefined }, duration: Array<{ type: DurationType, units?: DurationUnit | undefined, concentration?: boolean | undefined, upTo?: boolean | undefined, amount?: number | undefined, ends?: Array<string> | undefined }>, source?: Array<{ book: string, page?: number | undefined }> | undefined, classes?: Array<{ id: string, title: string }> | undefined, feats?: Array<{ id: string, title: string }> | undefined, features?: Array<{ id: string, title: string, subClassId?: string | undefined, classId?: string | undefined, type?: FeatureType | undefined, subClass?: { classId: string } | undefined }> | undefined, subClasses?: Array<{ id: string, title: string, classId: string }> | undefined, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type WizardSpellsQueryVariables = Exact<{ [key: string]: never; }>;


export type WizardSpellsQuery = { spells: Array<{ id: string, title: string, originalTitle: string, level: number }> };

export type SubClassQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type SubClassQuery = { subClass: { classTitle: string, id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, shortDescription?: string | undefined, classId: string, order?: number | undefined, props?: any | undefined, caption: string, source?: Array<{ book: string, page?: number | undefined }> | undefined, features: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }>, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type UpdateSubClassMutationVariables = Exact<{
  id: Scalars['String']['input'];
  subClass: SubClassInput;
}>;


export type UpdateSubClassMutation = { updateSubClass: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description: string, shortDescription?: string | undefined, classId: string, order?: number | undefined, props?: any | undefined, caption: string, source?: Array<{ book: string, page?: number | undefined }> | undefined, features: Array<{ id: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, description?: string | undefined, levels?: Array<string> | undefined, levelTitles?: Array<string> | undefined, order?: number | undefined, parentId?: string | undefined, headingLevel?: string | undefined, prerequisite?: string | undefined, type?: FeatureType | undefined, props?: any | undefined, choose?: Array<any> | undefined, classId?: string | undefined, subClassId?: string | undefined, specieId?: string | undefined, featId?: string | undefined, option?: boolean | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined }>, images?: Array<{ id: string, path: string, credits?: string | undefined, description?: string | undefined, width?: number | undefined, height?: number | undefined, updatedAt: string }> | undefined } };

export type CurrentUserQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserQuery = { currentUser?: { id: string, nickname: string, email: string, loginAt?: string | undefined, isAdmin: boolean, isCommentsBlocked: boolean } | undefined };

export type DeletePasskeyMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeletePasskeyMutation = { deletePasskey: boolean };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  remember?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LoginMutation = { login: { id: string, nickname: string, email: string, loginAt?: string | undefined, isAdmin: boolean, isCommentsBlocked: boolean } };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { logout: boolean };

export type MyIdentitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type MyIdentitiesQuery = { myIdentities: Array<{ id: string, provider: string, createdAt: string }> };

export type MyPasskeysQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPasskeysQuery = { myPasskeys: Array<{ id: string, name: string, createdAt: string, lastUsedAt?: string | undefined }> };

export type OauthLoginMutationVariables = Exact<{
  provider: Scalars['String']['input'];
  code: Scalars['String']['input'];
  state: Scalars['String']['input'];
}>;


export type OauthLoginMutation = { oauthLogin: { id: string, nickname: string, email: string, loginAt?: string | undefined, isAdmin: boolean, isCommentsBlocked: boolean } };

export type OauthProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type OauthProvidersQuery = { oauthProviders: Array<string> };

export type OauthUrlQueryVariables = Exact<{
  provider: Scalars['String']['input'];
}>;


export type OauthUrlQuery = { oauthUrl: string };

export type PasskeyLoginOptionsMutationVariables = Exact<{ [key: string]: never; }>;


export type PasskeyLoginOptionsMutation = { passkeyLoginOptions: any };

export type PasskeyLoginMutationVariables = Exact<{
  response: Scalars['Any']['input'];
}>;


export type PasskeyLoginMutation = { passkeyLogin: { id: string, nickname: string, email: string, loginAt?: string | undefined, isAdmin: boolean, isCommentsBlocked: boolean } };

export type PasskeyRegisterMutationVariables = Exact<{
  response: Scalars['Any']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
}>;


export type PasskeyRegisterMutation = { passkeyRegister: { id: string } };

export type PasskeyRegistrationOptionsMutationVariables = Exact<{ [key: string]: never; }>;


export type PasskeyRegistrationOptionsMutation = { passkeyRegistrationOptions: any };

export type RegisterMutationVariables = Exact<{
  user: UserInput;
}>;


export type RegisterMutation = { register: boolean };

export type RequestPasswordResetMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type RequestPasswordResetMutation = { requestPasswordReset: boolean };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { resetPassword: boolean };

export type UnlinkIdentityMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type UnlinkIdentityMutation = { unlinkIdentity: boolean };

export type CreateWikiArticleMutationVariables = Exact<{
  id: Scalars['String']['input'];
  wikiArticle: WikiArticleInput;
}>;


export type CreateWikiArticleMutation = { createWikiArticle: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, tags?: Array<string> | undefined, types?: Array<string> | undefined, parentId?: string | undefined, infobox?: any | undefined, description?: string | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, ancestors: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, children: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, navboxes: Array<{ type: string, scope?: { id: string, title: string, originalTitle: string, types?: Array<string> | undefined } | undefined, articles: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }> }>, memberOf: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, members: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, gameMap?: { id: string, title: string } | undefined } };

export type DeleteWikiArticleMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteWikiArticleMutation = { deleteWikiArticle: boolean };

export type UpdateWikiArticleMutationVariables = Exact<{
  id: Scalars['String']['input'];
  wikiArticle: WikiArticleInput;
}>;


export type UpdateWikiArticleMutation = { updateWikiArticle: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, tags?: Array<string> | undefined, types?: Array<string> | undefined, parentId?: string | undefined, infobox?: any | undefined, description?: string | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, ancestors: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, children: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, navboxes: Array<{ type: string, scope?: { id: string, title: string, originalTitle: string, types?: Array<string> | undefined } | undefined, articles: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }> }>, memberOf: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, members: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, gameMap?: { id: string, title: string } | undefined } };

export type WikiArticleQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type WikiArticleQuery = { wikiArticle: { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, tags?: Array<string> | undefined, types?: Array<string> | undefined, parentId?: string | undefined, infobox?: any | undefined, description?: string | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, ancestors: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, children: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, navboxes: Array<{ type: string, scope?: { id: string, title: string, originalTitle: string, types?: Array<string> | undefined } | undefined, articles: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }> }>, memberOf: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, members: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, gameMap?: { id: string, title: string } | undefined } };

export type WikiArticleLinkFragment = { id: string, title: string, originalTitle: string, types?: Array<string> | undefined };

export type WikiArticleFragment = { id: string, updatedAt: string, title: string, originalTitle: string, alternativeTitles?: Array<string> | undefined, tags?: Array<string> | undefined, types?: Array<string> | undefined, parentId?: string | undefined, infobox?: any | undefined, description?: string | undefined, source?: Array<{ book: string, page?: number | undefined }> | undefined, ancestors: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, children: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, navboxes: Array<{ type: string, scope?: { id: string, title: string, originalTitle: string, types?: Array<string> | undefined } | undefined, articles: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }> }>, memberOf: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, members: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }>, gameMap?: { id: string, title: string } | undefined };

export type WikiArticlesQueryVariables = Exact<{ [key: string]: never; }>;


export type WikiArticlesQuery = { wikiArticles: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }> };

export type WikiHomeQueryVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type WikiHomeQuery = { world: { id: string, title: string, children: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }> }, faerun: { id: string, title: string, children: Array<{ infobox?: any | undefined, id: string, title: string, originalTitle: string, types?: Array<string> | undefined, children: Array<{ id: string, title: string, originalTitle: string, types?: Array<string> | undefined }> }> }, featured: Array<{ infobox?: any | undefined, id: string, title: string, originalTitle: string, types?: Array<string> | undefined }> };

export * from './operations';
